import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import * as ROUTES from "../constant/routes";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { IconBtn, BtnSmallWhite, BtnSmall, BtnSmallDisabled } from "./";
import ProfilePic from "../assets/images/profilePic.png";
import { useAuth } from "../hooks";
import DialogBox from "./dialog-box";
import { AuthContext } from "../context/auth";
import { Transition } from "@headlessui/react";
import moment from "moment";
import SearchPage from "../pages/searchPage";
import {
  updatePersonalProfile,
  deleteProfilePic,
  getMyPublication,
  getallNotification,
  logOut,
} from "../assets/Js/script";
import ReactTooltip from "react-tooltip";
import PopUp from "./pop_ups/pop_up";
import audio from "../assets/audio/ding.mp3";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../utils/Firebase";

export default function Navbar({from}) {
  const [modals, setModals] = useState({
    profile: false,
    profileDetails: false,
    menu: false,
    cartMenu: false,
    deleteImage: false,
    addImageNote: true,
    notification: false,
    notify: false,
  });
  const [miniLoader, setMiniLoader] = useState(false);
  const [firstletter, SetFirstLetter] = useState("");
  let { user, setUser, search, setSearch, notifySound, setNotifySound } = useContext(AuthContext);
  const [notification, setNotification] = useState(null);
  const [checkBox, setCheckBox] = useState();
  const [newNotification, setNewNotification] = useState(
    JSON.parse(localStorage.getItem("publisher-newNotification"))
      ? JSON.parse(localStorage.getItem("publisher-newNotification"))
      : false
  );
  const [personalProfile, setPersonalProfile] = useState({
    fullName: user.fullName,
    mobile: user.mobile,
    email: user.email,
    photo: user.photo,
    local: false,
    delImage: false,
  });

  const navigate = useNavigate();
  const audioRef = useRef();

  const token = JSON.parse(localStorage.getItem("auth"));
  // let socket;

  // if (token?.length > 2) {
  //   socket = io("https://apis.eprakashak.in/", {
  //     // withCredentials: true,
  //     // path: '/socket.io',
  //       // transports: ['websocket'],
  //       // secure: true,
  //     query: {
  //       token,
  //     },
  //   });
  // }

  function checkCheckBox(e) {
    const checkData = e.target.checked;
    setCheckBox(checkData);
  }

  async function handleProfileChange(e) {
    e.preventDefault();
    setMiniLoader(true);

    const { response } = await updatePersonalProfile(personalProfile, checkBox);

    if (response.status === "success") {
      setMiniLoader(false);
      setUser((prevState) => ({
        ...response.data,
      }));
      localStorage.setItem("user", JSON.stringify({ ...response.data }));
      setModals((prevState) => ({
        ...prevState,
        profileDetails: false,
        addImageNote: true,
        local: false,
        delImage: true,
      }));
    } else {
      setMiniLoader(false);
    }
  }

  async function handleSignout() {
    const { response, error } = await logOut();
    if (response.status == "success") {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
      setUser(null);
    }
  }

  async function deletePicture() {
    const { response } = await deleteProfilePic(personalProfile.photo);

    if (response.status === "success") {
      setPersonalProfile((prev) => ({ ...prev, photo: null }));
      localStorage.setItem("user", JSON.stringify({ ...user, photo: null }));
      setModals((prev) => ({ ...prev, deleteImage: false }));
    }
  }
  // useEffect(() => {
  //   function notifyMe() {
  //     setModals((prev) => ({ ...prev, notify: true }));
  //     setInterval(() => {
  //       setModals((prev) => ({ ...prev, notify: false }));
  //     }, 3000);
  //   }
  //   // notifyMe();
  // }, []);

  function handleChange({ target }) {
    const { name, value } = target;
    if (name === "photo") {
      setPersonalProfile((prevState) => ({
        ...prevState,
        local: true,
        delImage: true,
        [name]: target.files[0],
      }));
    } else {
      if (name === "mobile") {
        value.length <= 10 &&
          !isNaN(value) &&
          setPersonalProfile((prevState) => ({
            ...prevState,
            [name]: value,
          }));
      } else {
        setPersonalProfile((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  }

  const [myPublication, setMypublication] = useState({ local: false });



  useEffect(() => {
    (async () => {
      const { response } = await getMyPublication();
      setMypublication({ ...response?.data.companyDetails, local: false });
    })();

  }, [])


  useEffect(() => {

    const q = query(collection(db, process.env.REACT_APP_NOTIF_COLLECTION), where("userId", "==", user?.id));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notifs = [];
     
      querySnapshot.forEach((doc) => {
        notifs.push({ id: doc.id, ...doc.data() });
      });
      console.log(notifs, 'notttt')
      // notifySound


      setNotification(notifs)

      // return unsubscribe;
    });
  }, [])

  useMemo(() => {
    localStorage.setItem(
      "publisher-newNotification",
      JSON.stringify(newNotification)
    );
  }, [newNotification]);

  function getTime(time) {
    return moment(time).fromNow(true);
  }

  useEffect(() => {
    function firstletter() {
      SetFirstLetter(user?.fullName[0]);
    }
    firstletter();
  }, []);

  useEffect(() => {
    function handleClose() {
      setModals((prevState) => ({
        ...prevState,
        profile: false,
        cartMenu: false,
        notification: false,
      }));
    }
    ///--------------------
    window.addEventListener("click", handleClose);

    return () => {
      window.removeEventListener("click", handleClose);
    };
  }, []);

  return (
    <>
      <div className="hidden lg:flex sm:ml-10 lg:ml-0 lg:w-full mb-8 justify-between">
        <button
          onClick={() =>from!='Users'&& navigate(ROUTES.SEARCH_BOOK)}
          className={`flex relative sm:h-[43px] lg:h-[54px] items-center sm:w-[231px] ${search.length > 0 && "shadow-lg"
            }  min-w-[231px] lg:w-7/12 max-w-search border-1 border-solid border-primary-dark-20 `}
        >
          <IconBtn>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 17L13.1333 13.1333M15.2222 8.11111C15.2222 12.0385 12.0385 15.2222 8.11111 15.2222C4.18375 15.2222 1 12.0385 1 8.11111C1 4.18375 4.18375 1 8.11111 1C12.0385 1 15.2222 4.18375 15.2222 8.11111Z"
                stroke="#702963"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconBtn>
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className=" sm:h-[41px] lg:h-12 outline-0  w-11/12 min-w-32 max-w-search-bar  border-0 border-solid border-primary-light"
          />
         
        </button>
        <div className="flex relative">
          <ReactTooltip
            place="right"
            backgroundColor="#737272"
            type="success"
            effect="solid"
            offset={{ bottom: 5 }}
            delayShow="200"
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              setModals((prevState) => ({ ...prevState, cartMenu: true }));
            }}
            className=" focus:outline-none outline-0 border-0 px-3"
          >
            <svg
              data-tip="Cart"
              width="27"
              height="24"
              viewBox="0 0 27 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.714 10.287H25.741C26.206 10.287 26.626 10.479 26.926 10.789C27.236 11.09 27.428 11.51 27.428 11.975V12.003V12.029C27.428 12.494 27.236 12.914 26.926 13.214C26.625 13.524 26.205 13.716 25.74 13.716H25.712H25.512L23.971 22.585C23.9058 22.9836 23.697 23.3446 23.384 23.6L23.381 23.602C23.091 23.851 22.711 24.003 22.296 24.003H5.12902C4.71403 24.003 4.33402 23.851 4.04202 23.6L4.04402 23.602C3.73207 23.3486 3.52305 22.9902 3.45602 22.594L3.45502 22.584L1.91402 13.715H1.68602C1.22102 13.715 0.801025 13.523 0.501025 13.213C0.341972 13.0591 0.215546 12.8748 0.129296 12.6711C0.0430464 12.4673 -0.00125916 12.2482 -0.000975206 12.027V11.999V11.973C-0.000975206 11.508 0.191025 11.088 0.501025 10.788C0.802025 10.478 1.22202 10.286 1.68702 10.286H1.71502H1.71402L25.714 10.287ZM6.49102 21.001C6.60323 20.9933 6.71267 20.9627 6.8126 20.9111C6.91253 20.8595 7.00082 20.788 7.07202 20.701L7.07302 20.7C7.14899 20.6156 7.20669 20.5164 7.24249 20.4087C7.27828 20.301 7.2914 20.187 7.28102 20.074V20.077L6.85203 14.505C6.84437 14.3928 6.8138 14.2833 6.7622 14.1834C6.7106 14.0835 6.63907 13.9952 6.55202 13.924L6.55102 13.923C6.46667 13.847 6.36751 13.7893 6.25978 13.7535C6.15204 13.7177 6.03807 13.7046 5.92502 13.715H5.92802C5.81582 13.7226 5.70638 13.7532 5.60645 13.8048C5.50652 13.8564 5.41823 13.9279 5.34702 14.015L5.34602 14.016C5.27005 14.1003 5.21236 14.1995 5.17656 14.3072C5.14077 14.4149 5.12765 14.5289 5.13802 14.642V14.639L5.56702 20.211C5.5813 20.4269 5.67967 20.6287 5.84102 20.773L5.84202 20.774C5.9964 20.9205 6.20118 21.0021 6.41402 21.002H6.42502H6.42402L6.49102 21.001ZM11.996 20.145V14.573V14.565C11.9963 14.4539 11.974 14.3439 11.9303 14.2417C11.8866 14.1396 11.8226 14.0475 11.742 13.971C11.6653 13.8905 11.5729 13.8265 11.4706 13.7828C11.3683 13.7391 11.2582 13.7167 11.147 13.717H11.131C11.0199 13.7166 10.91 13.739 10.8078 13.7827C10.7057 13.8263 10.6135 13.8904 10.537 13.971C10.4565 14.0477 10.3925 14.1401 10.3489 14.2423C10.3052 14.3446 10.2828 14.4547 10.283 14.566V20.154C10.283 20.388 10.38 20.599 10.537 20.748C10.6138 20.8284 10.7061 20.8924 10.8084 20.9361C10.9107 20.9798 11.0208 21.0022 11.132 21.002H11.148C11.2591 21.0023 11.3691 20.9799 11.4712 20.9362C11.5734 20.8926 11.6655 20.8285 11.742 20.748C11.8236 20.6712 11.8886 20.5785 11.9329 20.4757C11.9773 20.3728 12.0001 20.262 12 20.15V20.144L11.996 20.145ZM17.139 20.145V14.573V14.565C17.1393 14.4539 17.117 14.3439 17.0733 14.2417C17.0296 14.1396 16.9656 14.0475 16.885 13.971C16.8083 13.8905 16.7159 13.8265 16.6136 13.7828C16.5113 13.7391 16.4012 13.7167 16.29 13.717H16.274C16.1629 13.7166 16.053 13.739 15.9508 13.7827C15.8487 13.8263 15.7565 13.8904 15.68 13.971C15.5996 14.0477 15.5355 14.1401 15.4919 14.2423C15.4482 14.3446 15.4258 14.4547 15.426 14.566V20.154C15.426 20.388 15.523 20.599 15.68 20.748C15.7568 20.8284 15.8491 20.8924 15.9514 20.9361C16.0537 20.9798 16.1638 21.0022 16.275 21.002H16.291C16.4021 21.0023 16.5121 20.9799 16.6142 20.9362C16.7164 20.8926 16.8085 20.8285 16.885 20.748C16.9666 20.6712 17.0316 20.5785 17.0759 20.4757C17.1203 20.3728 17.1431 20.262 17.143 20.15V20.144L17.139 20.145ZM21.853 20.211L22.282 14.639C22.2917 14.5263 22.2782 14.4128 22.2425 14.3055C22.2067 14.1982 22.1494 14.0993 22.074 14.015L22.075 14.016C22.004 13.9288 21.9159 13.857 21.8162 13.8051C21.7165 13.7532 21.6072 13.7222 21.495 13.714H21.492C21.3793 13.7043 21.2658 13.7177 21.1585 13.7535C21.0512 13.7893 20.9524 13.8466 20.868 13.922L20.869 13.921C20.7819 13.992 20.7101 14.0801 20.6582 14.1798C20.6063 14.2795 20.5752 14.3888 20.567 14.501V14.504L20.138 20.076C20.1283 20.1887 20.1418 20.3021 20.1776 20.4094C20.2133 20.5167 20.2707 20.6156 20.346 20.7L20.345 20.699C20.4161 20.7861 20.5041 20.8579 20.6039 20.9098C20.7036 20.9617 20.8129 20.9927 20.925 21.001H21.005C21.2181 21.001 21.4232 20.9194 21.578 20.773C21.7414 20.6289 21.8417 20.4263 21.857 20.209V20.206L21.853 20.211ZM6.37502 3.91095L5.13002 9.42895H3.36202L4.71403 3.52295C4.87703 2.73795 5.30402 2.07295 5.89602 1.60795L5.90302 1.60295C6.49879 1.11983 7.24299 0.857043 8.01003 0.858954H8.04803H8.04602H10.282V0.850954C10.282 0.616954 10.379 0.405954 10.536 0.256954C10.6129 0.176222 10.7053 0.111979 10.8078 0.0681387C10.9103 0.0242986 11.0206 0.00177972 11.132 0.00195413H16.294C16.528 0.00195413 16.739 0.0989541 16.888 0.255954C16.9685 0.332722 17.0325 0.425058 17.0762 0.527346C17.1198 0.629634 17.1423 0.739736 17.142 0.850954V0.858954H19.415C20.216 0.858954 20.951 1.13895 21.527 1.60695L21.521 1.60195C22.1276 2.07537 22.5474 2.748 22.706 3.50095L22.71 3.52195L24.062 9.42795H22.294L21.049 3.90995C20.9585 3.53128 20.7455 3.1931 20.443 2.94795L20.44 2.94495C20.1457 2.7019 19.7757 2.56926 19.394 2.56995H17.139V2.57795C17.1393 2.68904 17.117 2.79902 17.0733 2.90116C17.0296 3.0033 16.9656 3.09545 16.885 3.17195C16.8083 3.25243 16.7159 3.31645 16.6136 3.36011C16.5113 3.40378 16.4012 3.42618 16.29 3.42595H11.132C11.0209 3.42628 10.911 3.40392 10.8088 3.36024C10.7067 3.31657 10.6145 3.25249 10.538 3.17195C10.4576 3.09519 10.3935 3.00285 10.3499 2.90056C10.3062 2.79827 10.2838 2.68817 10.284 2.57695V2.56895H8.02903C7.64641 2.56852 7.27569 2.70188 6.98102 2.94595L6.98403 2.94395C6.68375 3.18714 6.47185 3.52238 6.38102 3.89795L6.37902 3.90995L6.37502 3.91095Z"
                fill="#702963"
              />
            </svg>
          </button>
          <button
            onClick={(e) => {
              setModals((prev) => ({
                ...prev,
                notification: !modals.notification,
              }));
              setNewNotification(false);
              e.stopPropagation();
            }}
            className="outline-0  focus:outline-none  border-0 px-2 sm:mr-2 lg:mr-0"
          >
            {/* <svg
              width="27"
              height="28"
              viewBox="0 0 27 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3579 28C14.3954 28 16.0997 26.4937 16.4911 24.5H8.22461C8.6162 26.4937 10.3206 28 12.3579 28Z"
                fill="#979797"
              />
              <path
                d="M23.0761 21.6172L23.076 21.6174C22.9339 22.3294 22.2602 22.8335 21.5099 22.8335H3.20061C2.48492 22.8335 1.83544 22.3763 1.66152 21.7103C1.5038 21.1051 1.70036 20.4949 2.12719 20.1163C3.94824 18.5192 4.98312 16.2022 4.98312 13.7527V10.5001C4.98312 6.24851 8.30203 2.8335 12.3581 2.8335C12.3667 2.8335 12.3753 2.83352 12.3839 2.83355C12.0466 3.76797 11.8581 4.77737 11.8581 5.8335C11.8581 10.4372 15.354 14.2395 19.7738 14.4873C19.9562 16.6501 20.9378 18.6788 22.5663 20.0949C22.9935 20.4671 23.192 21.0379 23.0761 21.6172Z"
                fill="#F8F3E9"
                stroke="#734D03"
              />
              <path
                d="M25.773 5.72738C25.773 8.89047 23.3005 11.4545 20.2502 11.4545C17.2 11.4545 14.7275 8.89047 14.7275 5.72738C14.7275 2.56428 17.2 0 20.2502 0C23.3005 0 25.773 2.56428 25.773 5.72738Z"
                fill="#702963"
              />
            </svg> */}
            {!newNotification ? (
              <svg
                data-tip="Notification"
                width="23"
                height="27"
                viewBox="0 0 23 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.7343 19.9644C20.2036 18 19.1229 17 19.1229 11.5844C19.1229 6.625 16.7075 4.85812 14.7196 4C14.4555 3.88625 14.2069 3.625 14.1265 3.34062C13.7778 2.09625 12.8002 1 11.5007 1C10.2012 1 9.22307 2.09688 8.87794 3.34188C8.79746 3.62937 8.5489 3.88625 8.28483 4C6.2945 4.85938 3.88155 6.62 3.88155 11.5844C3.87857 17 2.79786 18 1.26712 19.9644C0.632882 20.7781 1.18843 22 2.29775 22H20.7096C21.813 22 22.365 20.7744 21.7343 19.9644Z"
                  fill="#F6EEF4"
                  stroke="#7E4B75"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.3727 27C13.3176 27 14.9445 25.4937 15.3181 23.5H7.42732C7.80111 25.4937 9.42803 27 11.3727 27Z"
                  fill="#BB7AAF"
                />
              </svg>
            ) : (
              <svg
                data-tip="Notification"
                width="27"
                height="30"
                viewBox="0 0 27 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.7343 22.9644C20.2036 21 19.1229 20 19.1229 14.5844C19.1229 9.625 16.7075 7.85812 14.7196 7C14.4555 6.88625 14.2069 6.625 14.1265 6.34062C13.7778 5.09625 12.8002 4 11.5007 4C10.2012 4 9.22307 5.09688 8.87794 6.34188C8.79746 6.62937 8.5489 6.88625 8.28483 7C6.2945 7.85938 3.88155 9.62 3.88155 14.5844C3.87857 20 2.79786 21 1.26712 22.9644C0.632882 23.7781 1.18843 25 2.29775 25H20.7096C21.813 25 22.365 23.7744 21.7343 22.9644Z"
                  fill="#F6EEF4"
                  stroke="#7E4B75"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.3727 30C13.3176 30 14.9445 28.4937 15.3181 26.5H7.42732C7.80111 28.4937 9.42803 30 11.3727 30Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M27 7.50014C27 11.6423 23.6423 15 19.4999 15C15.3577 15 12 11.6423 12 7.50014C12 3.35799 15.3577 0 19.4999 0C23.6423 0 27 3.35799 27 7.50014Z"
                  fill="white"
                />
                <path
                  d="M25.0455 7.72738C25.0455 10.8905 22.573 13.4545 19.5226 13.4545C16.4725 13.4545 14 10.8905 14 7.72738C14 4.56428 16.4725 2 19.5226 2C22.573 2 25.0455 4.56428 25.0455 7.72738Z"
                  fill="#702963"
                />
              </svg>
            )}
          </button>

          <audio className="w-0" src={audio} ref={audioRef} ></audio>

          {/* {modals.notify && (
            <div className="z-[999] absolute top-[50px] right-[243px] flex flex-col w-[260px] bg-[#fff] shadow-xl ">
              <div
                onClick={() => navigate(ROUTES.NOTIFICATION)}
                className="cursor-pointer flex justify-between items-center p-4 w-full h-[79px] border-1 border-solid border-[#efefef]"
              >
                <div>
                  <p className="flex gap-1">
                    <span className="flex items-center gap-1 text-[#702963] font-[600] text-[14px] ">
                      Reset Password
                      <svg
                        width="3"
                        height="4"
                        viewBox="0 0 3 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="1.5" cy="2" r="1.5" fill="#45464F" />
                      </svg>
                    </span>
                    <span className="font-[500] text-[14px] text-[#6c6a6a]">
                      now
                    </span>
                  </p>
                  <p className="text-[12px] text-[#6c6a6a] font-[400] w-[155px] whitespace-nowrap overflow-hidden text-ellipsis ">
                    Lorem ipsum dolor sit amet
                  </p>
                </div>
                <span className="self-start mt-2">
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_6713_33960)">
                      <path
                        d="M2.20367 9.75H10.684C10.945 9.75001 11.2022 9.68715 11.4337 9.56675C11.6653 9.44634 11.8644 9.27193 12.0143 9.05828C12.1642 8.84462 12.2604 8.598 12.2949 8.33928C12.3293 8.08057 12.3009 7.81737 12.212 7.57196L10.6672 3.30092C10.4034 2.35176 9.8359 1.51514 9.05158 0.919029C8.26726 0.322914 7.30927 0.000114876 6.32413 5.51043e-10V5.51044e-10C5.2986 -1.60292e-05 4.30374 0.349693 3.50378 0.991389C2.70383 1.63308 2.14663 2.5284 1.92417 3.5295L0.651252 7.64617C0.576306 7.88921 0.559458 8.14646 0.602062 8.3972C0.644666 8.64795 0.745533 8.88519 0.896546 9.08984C1.04756 9.2945 1.2445 9.46085 1.47153 9.57551C1.69856 9.69017 1.94933 9.74993 2.20367 9.75Z"
                        fill="#737272"
                        fill-opacity="0.5"
                      />
                      <path
                        d="M3.8457 10.834C3.97002 11.4462 4.30218 11.9967 4.7859 12.392C5.26961 12.7874 5.87514 13.0034 6.49987 13.0034C7.1246 13.0034 7.73013 12.7874 8.21384 12.392C8.69756 11.9967 9.02972 11.4462 9.15404 10.834H3.8457Z"
                        fill="#737272"
                        fill-opacity="0.5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6713_33960">
                        <rect width="13" height="13" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </div>
              <div
                onClick={() => navigate(ROUTES.NOTIFICATION)}
                className="flex justify-center items-center w-full h-[44px] border-1 border-solid border-[#efefef] cursor-pointer "
              >
                <button className="decoration-[#6c6a6a] text-[#6c6a6a] text-[12px] font-[600] underline ">
                  See All
                </button>
              </div>
            </div>
          )} */}
          {modals.notification && (
            <div
              onClick={(e) => e.stopPropagation()}
              className="z-[999] absolute top-[50px] right-[243px] flex flex-col w-[260px] bg-[#fff] shadow-xl "
            >
              {notification
                ?.filter((item, i) => i < 7)
                .map((data, index) => (
                  <div
                    onClick={() => {
                      navigate(ROUTES.NOTIFICATION);
                    }}
                    className="cursor-pointer flex justify-between items-center p-4 w-full h-[59px] border-1 border-solid border-[#efefef]"
                  >
                    <div>
                      <p className="flex gap-1">
                        <span className="flex items-center gap-1 text-[#702963] font-[600] text-[14px] ">
                          {data.title}
                          <svg
                            width="3"
                            height="4"
                            viewBox="0 0 3 4"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="1.5" cy="2" r="1.5" fill="#45464F" />
                          </svg>
                        </span>
                        <span className="font-[500] text-[14px] text-[#6c6a6a]">
                          {getTime(data?.createdAt?.toDate())}
                        </span>
                      </p>
                      <p className="text-[12px] text-[#6c6a6a] font-[400] w-[155px] whitespace-nowrap overflow-hidden text-ellipsis ">
                        {data.message}
                      </p>
                    </div>
                    <span className="self-start mt-2">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_6713_33960)">
                          <path
                            d="M2.20367 9.75H10.684C10.945 9.75001 11.2022 9.68715 11.4337 9.56675C11.6653 9.44634 11.8644 9.27193 12.0143 9.05828C12.1642 8.84462 12.2604 8.598 12.2949 8.33928C12.3293 8.08057 12.3009 7.81737 12.212 7.57196L10.6672 3.30092C10.4034 2.35176 9.8359 1.51514 9.05158 0.919029C8.26726 0.322914 7.30927 0.000114876 6.32413 5.51043e-10V5.51044e-10C5.2986 -1.60292e-05 4.30374 0.349693 3.50378 0.991389C2.70383 1.63308 2.14663 2.5284 1.92417 3.5295L0.651252 7.64617C0.576306 7.88921 0.559458 8.14646 0.602062 8.3972C0.644666 8.64795 0.745533 8.88519 0.896546 9.08984C1.04756 9.2945 1.2445 9.46085 1.47153 9.57551C1.69856 9.69017 1.94933 9.74993 2.20367 9.75Z"
                            fill="#737272"
                            fill-opacity="0.5"
                          />
                          <path
                            d="M3.8457 10.834C3.97002 11.4462 4.30218 11.9967 4.7859 12.392C5.26961 12.7874 5.87514 13.0034 6.49987 13.0034C7.1246 13.0034 7.73013 12.7874 8.21384 12.392C8.69756 11.9967 9.02972 11.4462 9.15404 10.834H3.8457Z"
                            fill="#737272"
                            fill-opacity="0.5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_6713_33960">
                            <rect width="13" height="13" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                ))}

              <div
                onClick={() => navigate(ROUTES.NOTIFICATION)}
                className="flex justify-center items-center w-full h-[44px] border-1 border-solid border-[#efefef] cursor-pointer "
              >
                <button className="decoration-[#6c6a6a] text-[#6c6a6a] text-[12px] font-[600] underline ">
                  See All
                </button>
              </div>
            </div>
          )}
          {modals.cartMenu && (
            <div className="z-50 w-[174px] h-fit  bg-primary-white border-1 border-solid border-primary-light py-[5px] absolute top-14 -left-[133px]">
              <div className="absolute top-[-0.76rem] right-0">
                <svg
                  width="23"
                  height="12"
                  viewBox="0 0 23 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.4156 0.959546L23.0018 11.7669L0.976125 11.7602L12.4156 0.959546Z"
                    stroke="#70296359"
                    fill="white"
                  />
                </svg>
              </div>
              <button className="group hover:bg-[#f3ebf2] text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light">
                Books
                <span className="hidden group-hover:flex flex-col z-50 w-[174px] h-fit  bg-primary-white border-1 border-solid border-primary-light py-[5px] absolute top-[10px] left-[174px]">
                  <span
                    onClick={() => navigate(ROUTES.GENERATE_ACCESS_IDS)}
                    className="hover:bg-[#f3ebf2] flex justify-start items-center text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light"
                  >
                    Access Ids
                  </span>
                  <span
                    onClick={() => navigate(ROUTES.GENERATE_ORDER_IDS)}
                    className="hover:bg-[#f3ebf2] flex justify-start items-center text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light"
                  >
                    Order Ids
                  </span>
                </span>
              </button>
              <button className="group hover:bg-[#f3ebf2] text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light">
                Sets
                <span className="hidden group-hover:flex flex-col z-50 w-[174px] h-fit  bg-primary-white border-1 border-solid border-primary-light py-[5px] absolute top-[50px] left-[174px]">
                  <span
                    onClick={() =>
                      navigate(ROUTES.GENERATE_ACCESS_IDS_FOR_SETS)
                    }
                    className="hover:bg-[#f3ebf2] flex justify-start items-center text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light"
                  >
                    Access Ids
                  </span>
                  <span
                    onClick={() => navigate(ROUTES.GENERATE_ORDER_IDS_FOR_SETS)}
                    className="hover:bg-[#f3ebf2] flex justify-start items-center text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light"
                  >
                    Order Ids
                  </span>
                </span>
              </button>
              {/* <button
                onClick={() => navigate(ROUTES.BOOK_RENEWAL)}
                className="hover:bg-[#f3ebf2] text-left pl-3 h-[39px] w-full font-semibold text-[18px] leading-[22px] text-montserrat text-secondary-light"
              >
                Books
              </button> */}
            </div>
          )}

          <div className="flex items-center ml-1 md:ml-6 h-12">
            <button
              className={`w-[34px] h-[34px] rounded-full ${firstletter === "A" ? "bg-[#e6ad10]" : "bg-[#702963]"
                }`}
            >
              {personalProfile.photo ? (
                <img
                  className="block h-full w-full object-cover rounded-full "
                  src={
                    personalProfile.local
                      ? URL.createObjectURL(personalProfile?.photo)
                      : `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/profiles/${user?.photo}`
                  }
                  alt="Profile"
                />
              ) : (
                <span className="text-[#ffff] text-[23px] uppercase">
                  {firstletter}
                </span>
              )}
            </button>
            <div className="flex flex-col w-26 mx-2 h-full">
              <p className="text-mobile-h5 sm:text-tablet-h5 lg:text-h5 text-secondary-dark font-semibold ">
                {user.fullName}
              </p>
              <p className="text-mobile-p1 sm:text-tablet-h5 lg:text-h5 text-secondary-light">
                PID: {myPublication.clientId}
              </p>
            </div>
          </div>
          <button
            onClick={(e) => {
              setModals((prevState) => ({
                ...prevState,
                profile: !modals.profile,
              }));
              e.stopPropagation();
            }}
            className="w-4 flex justify-center items-center"
          >
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.6173 0.0104983C11.5082 0.0104982 11.9544 1.08764 11.3244 1.71761L6.7281 6.31389C6.33758 6.70441 5.70441 6.70441 5.31389 6.31389L0.717605 1.71761C0.0876402 1.08764 0.533806 0.0104984 1.42471 0.0104984L10.6173 0.0104983Z"
                fill="#737272"
              />
            </svg>
          </button>
          <Transition
            show={modals.profile}
            enter="transition-opacity duration-[200ms]"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-[500ms]"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="py-4 z-10 absolute bg-[#ffffff] shadow-[0_4px_4px_3px_rgba(181,181,181,0.14)] top-16 -right-[21px] w-60 h-[191px] border-1 border-solid border-[#e7e7e7]"
            >
              <div className="absolute -top-[18px] right-4">
                <svg
                  width="26"
                  height="18"
                  viewBox="0 0 26 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.2268 1.30174C12.8273 0.53997 13.9821 0.53997 14.5827 1.30174L25.055 14.5851C25.8307 15.5689 25.1299 17.0138 23.8771 17.0138H2.93234C1.67955 17.0138 0.978768 15.5689 1.75439 14.5851L12.2268 1.30174Z"
                    fill="white"
                    stroke="#E7E7E7"
                  />
                </svg>
              </div>

              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    profileDetails: true,
                    profile: false,
                  }))
                }
                className="flex items-center hover:bg-[#f0f0f0] px-5 text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
              >
                <span className="mr-5">
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.50016 15.75C13.4351 15.75 16.6252 12.7279 16.6252 9C16.6252 5.27213 13.4351 2.25 9.50016 2.25C5.56518 2.25 2.37516 5.27213 2.37516 9C2.37516 12.7279 5.56518 15.75 9.50016 15.75ZM9.50016 16.5C13.8725 16.5 17.4168 13.1423 17.4168 9C17.4168 4.85775 13.8725 1.5 9.50016 1.5C5.12779 1.5 1.5835 4.85775 1.5835 9C1.5835 13.1423 5.12779 16.5 9.50016 16.5Z"
                      fill="#8B8B8B"
                    />
                    <path
                      d="M4.75 13.3612C4.75 12.9738 5.05558 12.6464 5.4625 12.6037C8.51635 12.2834 10.4975 12.3123 13.5446 12.6108C13.6968 12.6259 13.841 12.6827 13.9597 12.7742C14.0783 12.8657 14.1663 12.988 14.2128 13.1261C14.2593 13.2642 14.2624 13.4121 14.2216 13.5518C14.1808 13.6915 14.098 13.8169 13.9832 13.9128C10.3871 16.8824 8.3319 16.8415 5.00333 13.9158C4.84104 13.7733 4.75 13.5708 4.75 13.3615V13.3612Z"
                      fill="#8B8B8B"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.5042 12.9837C10.4812 12.6875 8.52856 12.6597 5.50597 12.9766C5.30252 12.998 5.14616 13.1626 5.14616 13.3617C5.14616 13.469 5.19327 13.5706 5.27283 13.6411C6.92266 15.0909 8.1727 15.746 9.39464 15.7501C10.6209 15.7542 11.9383 15.1044 13.7235 13.6306C13.7802 13.5828 13.821 13.5204 13.841 13.451C13.861 13.3816 13.8592 13.3082 13.836 13.2397C13.8128 13.1712 13.7691 13.1106 13.7101 13.0652C13.6512 13.0199 13.5797 12.9917 13.5042 12.9841V12.9837ZM5.41929 12.2311C8.5052 11.9075 10.5152 11.9367 13.5861 12.2379C13.815 12.2605 14.032 12.3459 14.2105 12.4835C14.389 12.6212 14.5212 12.8052 14.591 13.0129C14.6608 13.2207 14.6652 13.4432 14.6036 13.6533C14.5419 13.8634 14.417 14.0519 14.244 14.1957C12.4331 15.6912 10.9249 16.5057 9.39226 16.5001C7.85524 16.4949 6.41362 15.6665 4.73489 14.1909C4.6147 14.0848 4.51888 13.9564 4.45343 13.8137C4.38798 13.6709 4.3543 13.517 4.35449 13.3614C4.35392 13.0818 4.46224 12.8118 4.65872 12.6032C4.85519 12.3946 5.12601 12.2619 5.41929 12.2307V12.2311Z"
                      fill="#8B8B8B"
                    />
                    <path
                      d="M12.6668 7.5C12.6668 8.29565 12.3332 9.05871 11.7393 9.62132C11.1455 10.1839 10.34 10.5 9.50016 10.5C8.66031 10.5 7.85486 10.1839 7.26099 9.62132C6.66713 9.05871 6.3335 8.29565 6.3335 7.5C6.3335 6.70435 6.66713 5.94129 7.26099 5.37868C7.85486 4.81607 8.66031 4.5 9.50016 4.5C10.34 4.5 11.1455 4.81607 11.7393 5.37868C12.3332 5.94129 12.6668 6.70435 12.6668 7.5Z"
                      fill="#8B8B8B"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.50016 9.75C10.1301 9.75 10.7341 9.51295 11.1795 9.09099C11.6249 8.66903 11.8752 8.09674 11.8752 7.5C11.8752 6.90326 11.6249 6.33097 11.1795 5.90901C10.7341 5.48705 10.1301 5.25 9.50016 5.25C8.87027 5.25 8.26618 5.48705 7.82078 5.90901C7.37539 6.33097 7.12516 6.90326 7.12516 7.5C7.12516 8.09674 7.37539 8.66903 7.82078 9.09099C8.26618 9.51295 8.87027 9.75 9.50016 9.75ZM9.50016 10.5C10.34 10.5 11.1455 10.1839 11.7393 9.62132C12.3332 9.05871 12.6668 8.29565 12.6668 7.5C12.6668 6.70435 12.3332 5.94129 11.7393 5.37868C11.1455 4.81607 10.34 4.5 9.50016 4.5C8.66031 4.5 7.85486 4.81607 7.26099 5.37868C6.66713 5.94129 6.3335 6.70435 6.3335 7.5C6.3335 8.29565 6.66713 9.05871 7.26099 9.62132C7.85486 10.1839 8.66031 10.5 9.50016 10.5Z"
                      fill="#8B8B8B"
                    />
                  </svg>
                </span>
                Personal Profile
              </button>

              <button
                onClick={() => navigate(ROUTES.BUSINESS_PROFILE)}
                className="flex items-center hover:bg-[#f0f0f0] px-5 text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
              >
                <span className="mr-5">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.625 11.1562C10.625 11.4498 10.3873 11.6875 10.0938 11.6875H6.90625C6.61273 11.6875 6.375 11.4498 6.375 11.1562V9.5625H0V14.3438C0 15.1938 0.74375 15.9375 1.59375 15.9375H15.4062C16.2563 15.9375 17 15.1938 17 14.3438V9.5625H10.625V11.1562ZM15.4062 4.25H12.75V2.65625C12.75 1.80625 12.0063 1.0625 11.1562 1.0625H5.84375C4.99375 1.0625 4.25 1.80625 4.25 2.65625V4.25H1.59375C0.74375 4.25 0 4.99375 0 5.84375V8.5H17V5.84375C17 4.99375 16.2563 4.25 15.4062 4.25ZM10.625 4.25H6.375V3.1875H10.625V4.25Z"
                      fill="#8B8B8B"
                    />
                  </svg>
                </span>
                Business Profile
              </button>
              <button
                onClick={() => navigate(ROUTES.SETTINGS)}
                className="flex items-center hover:bg-[#f0f0f0] px-5 text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
              >
                <span className="mr-5">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.1158 1.73325C12.4243 1.58586 11.7186 1.50769 11.0101 1.5C10.2841 1.5075 9.57775 1.58625 8.88554 1.73325C8.73793 1.76477 8.60434 1.83955 8.50346 1.94714C8.40259 2.05473 8.33948 2.18973 8.32297 2.33325L8.15875 3.741C8.13521 3.93956 8.06331 4.13011 7.94879 4.29738C7.83427 4.46466 7.68032 4.60403 7.49926 4.70433C7.3182 4.80463 7.11505 4.86308 6.90608 4.87501C6.69711 4.88693 6.48811 4.852 6.29582 4.773L4.9444 4.20525C4.80722 4.14761 4.65467 4.13209 4.50785 4.16084C4.36103 4.1896 4.22721 4.2612 4.1249 4.36575C3.14751 5.36404 2.41979 6.56075 1.9964 7.866C1.95179 8.00341 1.95309 8.15067 2.00011 8.28734C2.04714 8.42402 2.13755 8.54334 2.25882 8.62875L3.45861 9.4725C3.62737 9.59105 3.76456 9.74581 3.85912 9.9243C3.95367 10.1028 4.00294 10.3 4.00294 10.5C4.00294 10.7 3.95367 10.8972 3.85912 11.0757C3.76456 11.2542 3.62737 11.409 3.45861 11.5275L2.25882 12.3735C2.13771 12.4589 2.04739 12.5781 2.00038 12.7146C1.95336 12.8511 1.95197 12.9982 1.9964 13.1355C2.41892 14.4419 3.14611 15.6399 4.12332 16.6395C4.22554 16.7442 4.35932 16.8159 4.50615 16.8448C4.65297 16.8737 4.80557 16.8583 4.94282 16.8008L6.30054 16.2315C6.49171 16.1518 6.69982 16.1161 6.90809 16.1273C7.11636 16.1385 7.31896 16.1963 7.49954 16.296C7.86568 16.4985 8.11004 16.8548 8.15797 17.2568L8.3214 18.6645C8.33781 18.8061 8.39959 18.9394 8.4983 19.0462C8.59701 19.1531 8.72785 19.2283 8.87297 19.2615C10.2711 19.5797 11.7279 19.5797 13.126 19.2615C13.2712 19.2283 13.402 19.1531 13.5007 19.0462C13.5994 18.9394 13.6612 18.8061 13.6776 18.6645L13.841 17.2545C13.8632 17.0558 13.9342 16.8649 14.0482 16.6974C14.1622 16.5298 14.3161 16.3903 14.4972 16.2902C14.6784 16.19 14.8817 16.1321 15.0907 16.1212C15.2997 16.1102 15.5085 16.1464 15.7 16.227L17.057 16.7963C17.1942 16.8538 17.3468 16.8692 17.4936 16.8403C17.6405 16.8114 17.7743 16.7397 17.8765 16.635C18.8532 15.6365 19.5803 14.4398 20.0034 13.1348C20.048 12.9973 20.0467 12.8501 19.9997 12.7134C19.9527 12.5767 19.8622 12.4574 19.741 12.372L18.5428 11.5275C18.3739 11.409 18.2367 11.2543 18.1421 11.0758C18.0474 10.8974 17.9981 10.7002 17.998 10.5002C17.998 10.3002 18.0471 10.103 18.1416 9.92444C18.2361 9.74592 18.3733 9.59111 18.542 9.4725L19.7402 8.62725C19.8612 8.54179 19.9513 8.42256 19.9982 8.28604C20.0451 8.14953 20.0463 8.00248 20.0018 7.86525C19.5787 6.56005 18.8513 5.36334 17.8741 4.365C17.7718 4.26045 17.638 4.18885 17.4912 4.16009C17.3443 4.13134 17.1918 4.14686 17.0546 4.2045L15.7032 4.77225C15.535 4.84371 15.353 4.88051 15.1689 4.88025C14.8398 4.87967 14.5224 4.76318 14.2777 4.5531C14.0329 4.34301 13.878 4.05411 13.8426 3.74175L13.6776 2.3325C13.6612 2.18928 13.5983 2.05453 13.4977 1.9471C13.3971 1.83966 13.2639 1.7649 13.1166 1.73325H13.1158ZM10.9999 13.5C10.1664 13.5 9.36696 13.1839 8.77756 12.6213C8.18816 12.0587 7.85704 11.2957 7.85704 10.5C7.85704 9.70435 8.18816 8.94129 8.77756 8.37868C9.36696 7.81607 10.1664 7.5 10.9999 7.5C11.8334 7.5 12.6328 7.81607 13.2222 8.37868C13.8116 8.94129 14.1428 9.70435 14.1428 10.5C14.1428 11.2957 13.8116 12.0587 13.2222 12.6213C12.6328 13.1839 11.8334 13.5 10.9999 13.5Z"
                      fill="#8B8B8B"
                    />
                  </svg>
                </span>
                Account Settings
              </button>
              <button
                onClick={handleSignout}
                className="flex items-center hover:bg-[#f0f0f0] px-5 text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
              >
                <span className="mr-5">
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.5 3.26562C2.5 2.1185 3.48 1.1875 4.6875 1.1875H7.8125C8.06114 1.1875 8.2996 1.28133 8.47541 1.44836C8.65123 1.61538 8.75 1.84192 8.75 2.07812C8.75 2.31433 8.65123 2.54087 8.47541 2.70789C8.2996 2.87492 8.06114 2.96875 7.8125 2.96875H4.6875C4.60462 2.96875 4.52513 3.00003 4.46653 3.0557C4.40792 3.11138 4.375 3.18689 4.375 3.26562V15.7344C4.375 15.8982 4.515 16.0312 4.6875 16.0312H7.8125C8.06114 16.0312 8.2996 16.1251 8.47541 16.2921C8.65123 16.4591 8.75 16.6857 8.75 16.9219C8.75 17.1581 8.65123 17.3846 8.47541 17.5516C8.2996 17.7187 8.06114 17.8125 7.8125 17.8125H4.6875C4.10734 17.8125 3.55094 17.5936 3.1407 17.2038C2.73047 16.8141 2.5 16.2855 2.5 15.7344V3.26562ZM15.55 8.60938H8.4375C8.18886 8.60938 7.9504 8.70321 7.77459 8.87023C7.59877 9.03726 7.5 9.26379 7.5 9.5C7.5 9.73621 7.59877 9.96274 7.77459 10.1298C7.9504 10.2968 8.18886 10.3906 8.4375 10.3906H15.55L13.0875 12.73C12.9954 12.8115 12.9215 12.9099 12.8703 13.0191C12.819 13.1284 12.7915 13.2463 12.7893 13.3659C12.787 13.4855 12.8102 13.6042 12.8573 13.7151C12.9045 13.826 12.9747 13.9268 13.0637 14.0114C13.1527 14.0959 13.2588 14.1626 13.3755 14.2074C13.4922 14.2522 13.6173 14.2742 13.7432 14.2721C13.869 14.27 13.9932 14.2438 14.1082 14.1951C14.2232 14.1464 14.3267 14.0763 14.4125 13.9887L18.475 10.1294C18.6506 9.96238 18.7492 9.73602 18.7492 9.5C18.7492 9.26398 18.6506 9.03762 18.475 8.87062L14.4125 5.01125C14.3267 4.92375 14.2232 4.85356 14.1082 4.80488C13.9932 4.75621 13.869 4.73003 13.7432 4.72792C13.6173 4.72581 13.4922 4.74781 13.3755 4.7926C13.2588 4.8374 13.1527 4.90407 13.0637 4.98864C12.9747 5.07321 12.9045 5.17395 12.8573 5.28485C12.8102 5.39575 12.787 5.51454 12.7893 5.63412C12.7915 5.75371 12.819 5.87164 12.8703 5.98089C12.9215 6.09014 12.9954 6.18846 13.0875 6.27L15.55 8.60938Z"
                      fill="#8B8B8B"
                    />
                  </svg>
                </span>
                Log Out
              </button>
            </div>
          </Transition>
        </div>
      </div>
      <div className="z-[999] flex fixed bottom-0 h-[60px] left-0 w-full border-1 border-solid border-primary-dark justify-evenly bg-[#fbfafb] items-center lg:hidden">
        <button
          onClick={() =>
            setModals((prevState) => ({ ...prevState, menu: true }))
          }
          className="w-[34px] flex justify-center items-center"
        >
          <svg
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8777 7.4615H1.11766C0.179256 7.4615 0.0976563 8.22941 0.0976563 9.17942C0.0976563 10.1294 0.179256 10.8973 1.11766 10.8973H22.8777C23.8161 10.8973 23.8977 10.1294 23.8977 9.17942C23.8977 8.22941 23.8161 7.4615 22.8777 7.4615ZM22.8777 14.3332H1.11766C0.179256 14.3332 0.0976563 15.1011 0.0976563 16.0511C0.0976563 17.0011 0.179256 17.769 1.11766 17.769H22.8777C23.8161 17.769 23.8977 17.0011 23.8977 16.0511C23.8977 15.1011 23.8161 14.3332 22.8777 14.3332ZM1.11766 4.02567H22.8777C23.8161 4.02567 23.8977 3.25777 23.8977 2.30776C23.8977 1.35775 23.8161 0.589844 22.8777 0.589844L1.11766 0.589844C0.179256 0.589844 0.0976563 1.35775 0.0976563 2.30776C0.0976563 3.25777 0.179256 4.02567 1.11766 4.02567Z"
              fill="#AAAAAA"
            />
          </svg>
        </button>
        <button className="w-[34px] flex justify-center items-center">
          <svg
            width="28"
            height="32"
            viewBox="0 0 28 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.108 31.1504C15.3314 31.1504 17.1913 29.5067 17.6184 27.3311H8.59766C9.02498 29.5067 10.8849 31.1504 13.108 31.1504Z"
              fill="#979797"
            />
            <path
              d="M24.3594 24.0955L24.3593 24.0959C24.2518 24.6345 23.7254 25.0575 23.0959 25.0575H3.11618C2.51519 25.0575 2.00761 24.6734 1.87642 24.1718C1.74685 23.6748 1.90997 23.1857 2.24553 22.8874C4.33241 21.0566 5.5157 18.4032 5.5157 15.6026V12.0533C5.5157 7.8644 8.62179 4.48677 12.5044 4.16646C12.2489 5.05178 12.1091 5.98896 12.1091 6.96091C12.1091 12.0781 15.8987 16.3505 20.7888 16.8282C21.0763 19.1547 22.1769 21.3241 23.9506 22.8664C24.2924 23.1645 24.4541 23.6219 24.3594 24.0955Z"
              stroke="#AAAAAA"
              stroke-width="2"
            />
            <path
              d="M27.7485 6.84463C27.7485 10.2963 25.0504 13.0943 21.7218 13.0943C18.3934 13.0943 15.6953 10.2963 15.6953 6.84463C15.6953 3.39296 18.3934 0.594727 21.7218 0.594727C25.0504 0.594727 27.7485 3.39296 27.7485 6.84463Z"
              fill="#AAAAAA"
            />
          </svg>
        </button>
        <button
          onClick={() => navigate(ROUTES.HOME)}
          className="w-[34px] flex justify-center items-center"
        >
          <svg
            width="30"
            height="28"
            viewBox="0 0 30 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.5611 17.3757V27.3038H4.44232V17.3757V17.1257H4.19232H2.86419C1.89673 17.1257 1.09694 16.3534 1.08605 15.3947L0.836067 15.3975L1.08605 15.3947C1.08339 15.1614 1.1275 14.9299 1.21577 14.7139C1.30405 14.4979 1.43469 14.3018 1.6 14.1372L1.6003 14.1369L14.4841 1.25928C14.4842 1.25917 14.4843 1.25907 14.4844 1.25896C14.622 1.12249 14.8079 1.0459 15.0017 1.0459C15.1955 1.0459 15.3814 1.12249 15.5189 1.25896C15.519 1.25906 15.5191 1.25917 15.5193 1.25928L16.328 2.06807L16.3281 2.06811L28.403 14.1368C28.4031 14.1368 28.4031 14.1368 28.4031 14.1369C28.7347 14.4685 28.9173 14.9082 28.9173 15.3725L28.9173 15.3735C28.9182 15.6034 28.8736 15.8311 28.7859 16.0435C28.6982 16.2559 28.5692 16.4489 28.4065 16.6111L28.4062 16.6114C28.0747 16.9429 27.635 17.1257 27.1673 17.1257H25.8111H25.5611V17.3757ZM16.7517 25.5538H17.0017V25.3038V18.9288V18.6788H16.7517H13.2517H13.0017V18.9288V25.3038V25.5538H13.2517H16.7517ZM6.19232 15.3757V25.3038V25.5538H6.44232H11.2517H11.5017V25.3038V18.1788C11.5017 17.6262 11.9491 17.1788 12.5017 17.1788H17.5017C18.0542 17.1788 18.5017 17.6262 18.5017 18.1788V25.3038V25.5538H18.7517H23.5611H23.8111V25.3038V15.3757H26.5642H27.168L26.7409 14.9488L15.9035 4.11764L15.9034 4.11759L15.1816 3.39576L15.0049 3.21906L14.8281 3.39569L3.26561 14.9488L2.83842 15.3757H3.44232H6.19232Z"
              fill="#AAAAAA"
              stroke="#AAAAAA"
              stroke-width="0.5"
            />
          </svg>
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setModals((prevState) => ({ ...prevState, profile: true }));
          }}
          className="w-[34px] flex justify-center items-center"
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.4"
              y="1.57871"
              width="31.2"
              height="31.2"
              rx="15.6"
              stroke="#AAAAAA"
              stroke-opacity="0.37"
              stroke-width="1.2"
            />
            <path
              d="M11.4805 25.3667C11.4805 25.3667 10.2305 25.3667 10.2305 24.1164C10.2305 22.8661 11.4805 19.1153 17.7305 19.1153C23.9805 19.1153 25.2305 22.8661 25.2305 24.1164C25.2305 25.3667 23.9805 25.3667 23.9805 25.3667H17.7305H11.4805ZM17.7305 17.865C18.725 17.865 19.6789 17.4698 20.3821 16.7664C21.0854 16.063 21.4805 15.1089 21.4805 14.1141C21.4805 13.1193 21.0854 12.1653 20.3821 11.4619C19.6789 10.7585 18.725 10.3633 17.7305 10.3633C16.7359 10.3633 15.7821 10.7585 15.0788 11.4619C14.3756 12.1653 13.9805 13.1193 13.9805 14.1141C13.9805 15.1089 14.3756 16.063 15.0788 16.7664C15.7821 17.4698 16.7359 17.865 17.7305 17.865Z"
              fill="#AAAAAA"
            />
          </svg>
        </button>
      </div>
      <Transition
        show={modals.menu}
        enter="transition-transform duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-transform duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="lg:hidden z-[999] bg-[rgba(112,41,99,0.24)] w-full h-screen fixed top-0 left-0"
      >
        <Transition.Child
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className="w-full absolute bottom-[60px] left-0 rounded-t-[30px] bg-primary-dark p-14 pb-12"
        >
          <button
            onClick={() => {
              setModals((prevState) => ({ ...prevState, menu: false }));
              navigate(ROUTES.HOME);
            }}
            className="mb-4 flex items-center text-[#bb7aaf] text-[20px] font-semibold"
          >
            <span className="mr-3">
              <svg
                width="32"
                height="28"
                viewBox="0 0 32 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_3420_16092" fill="white">
                  <path d="M26.1909 7.78175C24.1259 5.94618 21.4949 4.69614 18.6306 4.1897C15.7664 3.68327 12.7975 3.94319 10.0994 4.93659C7.40136 5.92999 5.09528 7.61226 3.47282 9.77067C1.85035 11.9291 0.984366 14.4667 0.984375 17.0625V21.875H9.84375V20.125H2.95312V17.0625C2.95312 10.7904 8.69381 5.68755 15.75 5.68755C22.8062 5.68755 28.5469 10.7904 28.5469 17.0625V20.125H21.6562V21.875H30.5156V17.0625C30.5209 15.3383 30.1414 13.6301 29.3991 12.0371C28.6567 10.444 27.5663 8.99769 26.1909 7.78175Z" />
                </mask>
                <path
                  d="M26.1909 7.78175C24.1259 5.94618 21.4949 4.69614 18.6306 4.1897C15.7664 3.68327 12.7975 3.94319 10.0994 4.93659C7.40136 5.92999 5.09528 7.61226 3.47282 9.77067C1.85035 11.9291 0.984366 14.4667 0.984375 17.0625V21.875H9.84375V20.125H2.95312V17.0625C2.95312 10.7904 8.69381 5.68755 15.75 5.68755C22.8062 5.68755 28.5469 10.7904 28.5469 17.0625V20.125H21.6562V21.875H30.5156V17.0625C30.5209 15.3383 30.1414 13.6301 29.3991 12.0371C28.6567 10.444 27.5663 8.99769 26.1909 7.78175Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M26.1909 7.78175L24.8622 9.27657L24.8662 9.28016L26.1909 7.78175ZM0.984375 17.0625H2.98438V17.0625L0.984375 17.0625ZM0.984375 21.875H-1.01562V23.875H0.984375V21.875ZM9.84375 21.875V23.875H11.8437V21.875H9.84375ZM9.84375 20.125H11.8437V18.125H9.84375V20.125ZM2.95312 20.125H0.953125V22.125H2.95312V20.125ZM28.5469 20.125V22.125H30.5469V20.125H28.5469ZM21.6562 20.125V18.125H19.6562V20.125H21.6562ZM21.6562 21.875H19.6562V23.875H21.6562V21.875ZM30.5156 21.875V23.875H32.5156V21.875H30.5156ZM30.5156 17.0625L28.5156 17.0564V17.0625H30.5156ZM27.5196 6.28693C25.1631 4.19225 22.1875 2.78757 18.9789 2.22025L18.2824 6.15915C20.8023 6.6047 23.0887 7.7001 24.8622 9.27657L27.5196 6.28693ZM18.9789 2.22025C15.7704 1.65295 12.4426 1.94258 9.4084 3.05976L10.7905 6.81342C13.1524 5.94379 15.7624 5.71358 18.2824 6.15915L18.9789 2.22025ZM9.4084 3.05976C6.37363 4.17714 3.74309 6.08261 1.87412 8.56893L5.07151 10.9724C6.44748 9.14192 8.42909 7.68285 10.7905 6.81342L9.4084 3.05976ZM1.87412 8.56893C0.00240678 11.0589 -1.01564 14.0149 -1.01562 17.0626L2.98438 17.0625C2.98437 14.9185 3.69829 12.7992 5.07151 10.9724L1.87412 8.56893ZM-1.01562 17.0625V21.875H2.98438V17.0625H-1.01562ZM0.984375 23.875H9.84375V19.875H0.984375V23.875ZM11.8437 21.875V20.125H7.84375V21.875H11.8437ZM9.84375 18.125H2.95312V22.125H9.84375V18.125ZM4.95312 20.125V17.0625H0.953125V20.125H4.95312ZM4.95312 17.0625C4.95312 12.1099 9.57042 7.68755 15.75 7.68755V3.68755C7.81721 3.68755 0.953125 9.47087 0.953125 17.0625H4.95312ZM15.75 7.68755C21.9296 7.68755 26.5469 12.1099 26.5469 17.0625H30.5469C30.5469 9.47087 23.6828 3.68755 15.75 3.68755V7.68755ZM26.5469 17.0625V20.125H30.5469V17.0625H26.5469ZM28.5469 18.125H21.6562V22.125H28.5469V18.125ZM19.6562 20.125V21.875H23.6562V20.125H19.6562ZM21.6562 23.875H30.5156V19.875H21.6562V23.875ZM32.5156 21.875V17.0625H28.5156V21.875H32.5156ZM32.5156 17.0687C32.5218 15.0447 32.0759 13.0465 31.2119 11.1923L27.5862 12.8819C28.2069 14.2138 28.52 15.6318 28.5156 17.0564L32.5156 17.0687ZM31.2119 11.1923C30.3483 9.33909 29.0875 7.67303 27.5156 6.28334L24.8662 9.28016C26.0451 10.3223 26.9651 11.549 27.5862 12.8819L31.2119 11.1923Z"
                  fill="#BB7AAF"
                  mask="url(#path-1-inside-1_3420_16092)"
                />
                <path
                  d="M4.92188 14.4375H6.89062V16.1875H4.92188V14.4375Z"
                  fill="#BB7AAF"
                />
                <path d="M14.7656 7H16.7344V8.75H14.7656V7Z" fill="#BB7AAF" />
                <path
                  d="M8.36719 9.1875H10.3359V10.9375H8.36719V9.1875Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M24.6094 14.4375H26.5781V16.1875H24.6094V14.4375Z"
                  fill="#BB7AAF"
                />
                <mask id="path-7-inside-2_3420_16092" fill="white">
                  <path d="M18.2842 18.3263L22.5416 10.4419L20.7667 9.68457L16.5103 17.567C15.5682 17.4001 14.5899 17.5444 13.759 17.9729C12.928 18.4014 12.3014 19.0846 11.9967 19.8945C11.692 20.7043 11.7301 21.5851 12.1039 22.3717C12.4776 23.1584 13.1614 23.7968 14.0269 24.1673C14.8924 24.5379 15.8802 24.615 16.8052 24.3843C17.7301 24.1536 18.5286 23.631 19.051 22.9143C19.5733 22.1977 19.7836 21.3362 19.6425 20.4916C19.5013 19.6469 19.0184 18.8771 18.2842 18.3263ZM15.7481 22.7506C15.3587 22.7506 14.9781 22.6479 14.6543 22.4556C14.3306 22.2633 14.0782 21.99 13.9292 21.6703C13.7802 21.3505 13.7412 20.9986 13.8172 20.6592C13.8931 20.3197 14.0806 20.0079 14.356 19.7631C14.6313 19.5184 14.9821 19.3517 15.364 19.2842C15.7459 19.2167 16.1418 19.2513 16.5015 19.3838C16.8612 19.5162 17.1687 19.7405 17.3851 20.0283C17.6014 20.3161 17.7168 20.6544 17.7168 21.0006C17.7163 21.4645 17.5087 21.9093 17.1396 22.2374C16.7705 22.5655 16.2701 22.75 15.7481 22.7506Z" />
                </mask>
                <path
                  d="M18.2842 18.3263L22.5416 10.4419L20.7667 9.68457L16.5103 17.567C15.5682 17.4001 14.5899 17.5444 13.759 17.9729C12.928 18.4014 12.3014 19.0846 11.9967 19.8945C11.692 20.7043 11.7301 21.5851 12.1039 22.3717C12.4776 23.1584 13.1614 23.7968 14.0269 24.1673C14.8924 24.5379 15.8802 24.615 16.8052 24.3843C17.7301 24.1536 18.5286 23.631 19.051 22.9143C19.5733 22.1977 19.7836 21.3362 19.6425 20.4916C19.5013 19.6469 19.0184 18.8771 18.2842 18.3263ZM15.7481 22.7506C15.3587 22.7506 14.9781 22.6479 14.6543 22.4556C14.3306 22.2633 14.0782 21.99 13.9292 21.6703C13.7802 21.3505 13.7412 20.9986 13.8172 20.6592C13.8931 20.3197 14.0806 20.0079 14.356 19.7631C14.6313 19.5184 14.9821 19.3517 15.364 19.2842C15.7459 19.2167 16.1418 19.2513 16.5015 19.3838C16.8612 19.5162 17.1687 19.7405 17.3851 20.0283C17.6014 20.3161 17.7168 20.6544 17.7168 21.0006C17.7163 21.4645 17.5087 21.9093 17.1396 22.2374C16.7705 22.5655 16.2701 22.75 15.7481 22.7506Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M18.2842 18.3263L16.5244 17.3761L15.7057 18.8922L17.0841 19.9262L18.2842 18.3263ZM22.5416 10.4419L24.3015 11.3921L25.3433 9.46281L23.3265 8.60233L22.5416 10.4419ZM20.7667 9.68457L21.5516 7.84501L19.8736 7.1291L19.0069 8.73429L20.7667 9.68457ZM16.5103 17.567L16.1615 19.5363L17.5838 19.7882L18.2701 18.5172L16.5103 17.567ZM15.7481 22.7506V24.7506L15.7501 24.7506L15.7481 22.7506ZM17.7168 21.0006L19.7168 21.0031V21.0006H17.7168ZM20.044 19.2766L24.3015 11.3921L20.7818 9.49162L16.5244 17.3761L20.044 19.2766ZM23.3265 8.60233L21.5516 7.84501L19.9818 11.5241L21.7568 12.2814L23.3265 8.60233ZM19.0069 8.73429L14.7505 16.6167L18.2701 18.5172L22.5265 10.6348L19.0069 8.73429ZM16.8591 15.5976C15.4964 15.3562 14.0724 15.561 12.8423 16.1953L14.6756 19.7505C15.1074 19.5278 15.6399 19.4439 16.1615 19.5363L16.8591 15.5976ZM12.8423 16.1953C11.6096 16.831 10.6187 17.8775 10.1248 19.1902L13.8686 20.5988C13.9841 20.2917 14.2464 19.9718 14.6756 19.7505L12.8423 16.1953ZM10.1248 19.1902C9.62753 20.5119 9.69238 21.9566 10.2974 23.23L13.9103 21.5134C13.7679 21.2136 13.7565 20.8967 13.8686 20.5988L10.1248 19.1902ZM10.2974 23.23C10.8979 24.4939 11.9658 25.4605 13.2398 26.006L14.814 22.3287C14.357 22.1331 14.0574 21.8229 13.9103 21.5134L10.2974 23.23ZM13.2398 26.006C14.5119 26.5505 15.9465 26.6598 17.2892 26.3249L16.3212 22.4438C15.814 22.5703 15.2729 22.5252 14.814 22.3287L13.2398 26.006ZM17.2892 26.3249C18.6325 25.9898 19.8471 25.2176 20.6672 24.0924L17.4347 21.7363C17.2102 22.0443 16.8277 22.3174 16.3212 22.4438L17.2892 26.3249ZM20.6672 24.0924C21.4935 22.9587 21.8483 21.5574 21.6151 20.1619L17.6698 20.8213C17.719 21.1151 17.6532 21.4366 17.4347 21.7363L20.6672 24.0924ZM21.6151 20.1619C21.3828 18.7718 20.5973 17.5613 19.4844 16.7265L17.0841 19.9262C17.4395 20.1928 17.6199 20.5221 17.6698 20.8213L21.6151 20.1619ZM15.7481 20.7506C15.7054 20.7506 15.6795 20.7384 15.6756 20.7361L13.633 24.1752C14.2767 24.5575 15.0121 24.7506 15.7481 24.7506V20.7506ZM15.6756 20.7361C15.6731 20.7346 15.7095 20.7557 15.742 20.8255L12.1164 22.515C12.4469 23.2244 12.988 23.7921 13.633 24.1752L15.6756 20.7361ZM15.742 20.8255C15.7766 20.8997 15.7908 20.998 15.7689 21.0959L11.8654 20.2224C11.6916 20.9992 11.7838 21.8012 12.1164 22.515L15.742 20.8255ZM15.7689 21.0959C15.7477 21.1906 15.7032 21.2415 15.6847 21.2579L13.0273 18.2683C12.4581 18.7742 12.0386 19.4487 11.8654 20.2224L15.7689 21.0959ZM15.6847 21.2579C15.6758 21.2658 15.6728 21.2663 15.6783 21.2637C15.6839 21.261 15.6952 21.2566 15.7122 21.2536L15.0158 17.3147C14.2895 17.4431 13.5941 17.7645 13.0273 18.2683L15.6847 21.2579ZM15.7122 21.2536C15.7499 21.247 15.7869 21.2519 15.8105 21.2606L17.1925 17.5069C16.4966 17.2507 15.7419 17.1863 15.0158 17.3147L15.7122 21.2536ZM15.8105 21.2606C15.8206 21.2643 15.8227 21.2667 15.8184 21.2636C15.8141 21.2604 15.8017 21.2505 15.7864 21.2301L18.9837 18.8266C18.5209 18.2109 17.889 17.7634 17.1925 17.5069L15.8105 21.2606ZM15.7864 21.2301C15.7534 21.1863 15.7168 21.1062 15.7168 21.0006H19.7168C19.7168 20.2027 19.4493 19.4459 18.9837 18.8266L15.7864 21.2301ZM15.7169 20.998C15.717 20.8514 15.7846 20.7659 15.8108 20.7426L18.4683 23.7322C19.2327 23.0528 19.7155 22.0776 19.7168 21.0031L15.7169 20.998ZM15.8108 20.7426C15.8222 20.7325 15.8234 20.7351 15.8092 20.7404C15.795 20.7456 15.7731 20.7505 15.7461 20.7506L15.7501 24.7506C16.7308 24.7496 17.7115 24.4049 18.4683 23.7322L15.8108 20.7426Z"
                  fill="#BB7AAF"
                  mask="url(#path-7-inside-2_3420_16092)"
                />
              </svg>
            </span>
            Metrics
          </button>
          <button
            onClick={() => {
              setModals((prevState) => ({ ...prevState, menu: false }));
              navigate(ROUTES.CATALOGUE);
            }}
            className="mb-4 flex items-center text-[#bb7aaf] text-[20px] font-semibold"
          >
            <span className="mr-5">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 1.33344C0 0.979787 0.140468 0.640622 0.390501 0.390555C0.640535 0.140487 0.979654 0 1.33326 0H5.33302C5.68662 0 6.02574 0.140487 6.27578 0.390555C6.52581 0.640622 6.66628 0.979787 6.66628 1.33344V5.33375C6.66628 5.6874 6.52581 6.02656 6.27578 6.27663C6.02574 6.5267 5.68662 6.66718 5.33302 6.66718H1.33326C0.979654 6.66718 0.640535 6.5267 0.390501 6.27663C0.140468 6.02656 0 5.6874 0 5.33375V1.33344Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M0 10.0034C0 9.64971 0.140468 9.31054 0.390501 9.06048C0.640535 8.81041 0.979654 8.66992 1.33326 8.66992H5.33302C5.68662 8.66992 6.02574 8.81041 6.27578 9.06048C6.52581 9.31054 6.66628 9.64971 6.66628 10.0034V14.0037C6.66628 14.3573 6.52581 14.6965 6.27578 14.9466C6.02574 15.1966 5.68662 15.3371 5.33302 15.3371H1.33326C0.979654 15.3371 0.640535 15.1966 0.390501 14.9466C0.140468 14.6965 0 14.3573 0 14.0037V10.0034Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M0 18.6655C0 18.3118 0.140468 17.9727 0.390501 17.7226C0.640535 17.4725 0.979654 17.332 1.33326 17.332H5.33302C5.68662 17.332 6.02574 17.4725 6.27578 17.7226C6.52581 17.9727 6.66628 18.3118 6.66628 18.6655V22.6658C6.66628 23.0194 6.52581 23.3586 6.27578 23.6087C6.02574 23.8587 5.68662 23.9992 5.33302 23.9992H1.33326C0.979654 23.9992 0.640535 23.8587 0.390501 23.6087C0.140468 23.3586 0 23.0194 0 22.6658V18.6655Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M8.66797 1.33344C8.66797 0.979787 8.80844 0.640622 9.05847 0.390555C9.3085 0.140487 9.64762 0 10.0012 0H14.001C14.3546 0 14.6937 0.140487 14.9437 0.390555C15.1938 0.640622 15.3342 0.979787 15.3342 1.33344V5.33375C15.3342 5.6874 15.1938 6.02656 14.9437 6.27663C14.6937 6.5267 14.3546 6.66718 14.001 6.66718H10.0012C9.64762 6.66718 9.3085 6.5267 9.05847 6.27663C8.80844 6.02656 8.66797 5.6874 8.66797 5.33375V1.33344Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M8.66797 10.0014C8.66797 9.64776 8.80844 9.30859 9.05847 9.05852C9.3085 8.80846 9.64762 8.66797 10.0012 8.66797H14.001C14.3546 8.66797 14.6937 8.80846 14.9437 9.05852C15.1938 9.30859 15.3342 9.64776 15.3342 10.0014V14.0017C15.3342 14.3554 15.1938 14.6945 14.9437 14.9446C14.6937 15.1947 14.3546 15.3352 14.001 15.3352H10.0012C9.64762 15.3352 9.3085 15.1947 9.05847 14.9446C8.80844 14.6945 8.66797 14.3554 8.66797 14.0017V10.0014Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M8.66797 18.6655C8.66797 18.3118 8.80844 17.9727 9.05847 17.7226C9.3085 17.4725 9.64762 17.332 10.0012 17.332H14.001C14.3546 17.332 14.6937 17.4725 14.9437 17.7226C15.1938 17.9727 15.3342 18.3118 15.3342 18.6655V22.6658C15.3342 23.0194 15.1938 23.3586 14.9437 23.6087C14.6937 23.8587 14.3546 23.9992 14.001 23.9992H10.0012C9.64762 23.9992 9.3085 23.8587 9.05847 23.6087C8.80844 23.3586 8.66797 23.0194 8.66797 22.6658V18.6655Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M17.3359 1.33344C17.3359 0.979787 17.4764 0.640622 17.7264 0.390555C17.9765 0.140487 18.3156 0 18.6692 0H22.669C23.0226 0 23.3617 0.140487 23.6117 0.390555C23.8617 0.640622 24.0022 0.979787 24.0022 1.33344V5.33375C24.0022 5.6874 23.8617 6.02656 23.6117 6.27663C23.3617 6.5267 23.0226 6.66718 22.669 6.66718H18.6692C18.3156 6.66718 17.9765 6.5267 17.7264 6.27663C17.4764 6.02656 17.3359 5.6874 17.3359 5.33375V1.33344Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M17.332 10.0014C17.332 9.64776 17.4725 9.30859 17.7225 9.05852C17.9726 8.80846 18.3117 8.66797 18.6653 8.66797H22.6651C23.0187 8.66797 23.3578 8.80846 23.6078 9.05852C23.8578 9.30859 23.9983 9.64776 23.9983 10.0014V14.0017C23.9983 14.3554 23.8578 14.6945 23.6078 14.9446C23.3578 15.1947 23.0187 15.3352 22.6651 15.3352H18.6653C18.3117 15.3352 17.9726 15.1947 17.7225 14.9446C17.4725 14.6945 17.332 14.3554 17.332 14.0017V10.0014Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M17.332 18.6655C17.332 18.3118 17.4725 17.9727 17.7225 17.7226C17.9726 17.4725 18.3117 17.332 18.6653 17.332H22.6651C23.0187 17.332 23.3578 17.4725 23.6078 17.7226C23.8578 17.9727 23.9983 18.3118 23.9983 18.6655V22.6658C23.9983 23.0194 23.8578 23.3586 23.6078 23.6087C23.3578 23.8587 23.0187 23.9992 22.6651 23.9992H18.6653C18.3117 23.9992 17.9726 23.8587 17.7225 23.6087C17.4725 23.3586 17.332 23.0194 17.332 22.6658V18.6655Z"
                  fill="#BB7AAF"
                />
              </svg>
            </span>
            Catalogue
          </button>
          <button
            onClick={() => {
              setModals((prevState) => ({ ...prevState, menu: false }));
              navigate(ROUTES.USERS);
            }}
            className="mb-5 flex items-center text-[#bb7aaf] text-[20px] font-semibold"
          >
            <span className="mr-[21px]">
              <svg
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.7286 9.51008C19.5829 10.3788 18.1159 10.9013 16.5189 10.9013C15.9661 10.9013 15.4288 10.8386 14.9152 10.7209C15.8337 12.0075 16.3689 13.5454 16.3689 15.1963V17.6211C16.3689 18.528 16.0089 19.3586 15.4145 20H21.4142C22.84 20 24 18.9329 24 17.6211V15.1963C24 12.8364 22.702 10.7503 20.7286 9.51008Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M7.48136 9.6076C10.3607 9.6076 12.7032 7.45268 12.7032 4.80388C12.7032 2.15492 10.3607 0 7.48136 0C4.60202 0 2.25955 2.15492 2.25955 4.80388C2.25955 7.45268 4.60202 9.6076 7.48136 9.6076Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M16.5186 9.6076C19.3979 9.6076 21.7406 7.45268 21.7406 4.80388C21.7406 2.15492 19.3979 0 16.5186 0C15.1257 0 13.8586 0.504325 12.9213 1.32482C13.6697 2.31225 14.1093 3.51157 14.1093 4.80388C14.1093 6.09603 13.6697 7.29536 12.9213 8.28278C13.8586 9.10328 15.1257 9.6076 16.5186 9.6076Z"
                  fill="#BB7AAF"
                />
                <path
                  d="M11.6911 9.51008C10.5456 10.3788 9.07856 10.9013 7.48133 10.9013C5.8841 10.9013 4.41706 10.3789 3.27137 9.51008C1.29804 10.7503 0 12.8364 0 15.1963V17.6211C0 18.9329 1.15997 20 2.586 20H12.3765C13.8025 20 14.9625 18.9329 14.9625 17.6211V15.1963C14.9625 12.8364 13.6646 10.7503 11.6911 9.51008Z"
                  fill="#BB7AAF"
                />
              </svg>
            </span>
            Users
          </button>
          <button
            onClick={() => {
              setModals((prevState) => ({ ...prevState, menu: false }));
              navigate(ROUTES.ADD_NEW_BOOK);
            }}
            className="flex items-center text-[#bb7aaf] text-[20px] font-semibold"
          >
            <span className="mr-[21px]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 0C2.20435 0 1.44129 0.30102 0.87868 0.836838C0.316071 1.37266 0 2.09938 0 2.85714V20C0 20.7578 0.316071 21.4845 0.87868 22.0203C1.44129 22.5561 2.20435 22.8571 3 22.8571H11.772C11.2575 22.3471 10.822 21.7699 10.4784 21.1429H3C2.68174 21.1429 2.37652 21.0225 2.15147 20.8081C1.92643 20.5938 1.8 20.3031 1.8 20H9.9756C9.53256 18.6977 9.47598 17.3041 9.81212 15.9732C10.1483 14.6422 10.864 13.4255 11.8804 12.4575C12.8968 11.4895 14.1743 10.8079 15.5718 10.4877C16.9694 10.1676 18.4326 10.2215 19.8 10.6434V2.85714C19.8 2.09938 19.4839 1.37266 18.9213 0.836838C18.3587 0.30102 17.5956 0 16.8 0H3ZM4.8 3.42857H14.4C14.7183 3.42857 15.0235 3.54898 15.2485 3.76331C15.4736 3.97763 15.6 4.26832 15.6 4.57143V5.71429C15.6 6.01739 15.4736 6.30808 15.2485 6.52241C15.0235 6.73674 14.7183 6.85714 14.4 6.85714H4.8C4.48174 6.85714 4.17652 6.73674 3.95147 6.52241C3.72643 6.30808 3.6 6.01739 3.6 5.71429V4.57143C3.6 4.26832 3.72643 3.97763 3.95147 3.76331C4.17652 3.54898 4.48174 3.42857 4.8 3.42857ZM24 17.7143C24 16.0472 23.3046 14.4484 22.0669 13.2696C20.8292 12.0908 19.1504 11.4286 17.4 11.4286C15.6496 11.4286 13.9708 12.0908 12.7331 13.2696C11.4954 14.4484 10.8 16.0472 10.8 17.7143C10.8 19.3814 11.4954 20.9802 12.7331 22.159C13.9708 23.3378 15.6496 24 17.4 24C19.1504 24 20.8292 23.3378 22.0669 22.159C23.3046 20.9802 24 19.3814 24 17.7143ZM18 18.2857L18.0012 21.1463C18.0012 21.2978 17.938 21.4432 17.8255 21.5503C17.7129 21.6575 17.5603 21.7177 17.4012 21.7177C17.2421 21.7177 17.0895 21.6575 16.9769 21.5503C16.8644 21.4432 16.8012 21.2978 16.8012 21.1463V18.2857H13.7952C13.6361 18.2857 13.4835 18.2255 13.3709 18.1183C13.2584 18.0112 13.1952 17.8658 13.1952 17.7143C13.1952 17.5627 13.2584 17.4174 13.3709 17.3102C13.4835 17.2031 13.6361 17.1429 13.7952 17.1429H16.8V14.2857C16.8 14.1342 16.8632 13.9888 16.9757 13.8817C17.0883 13.7745 17.2409 13.7143 17.4 13.7143C17.5591 13.7143 17.7117 13.7745 17.8243 13.8817C17.9368 13.9888 18 14.1342 18 14.2857V17.1429H21.0036C21.1627 17.1429 21.3153 17.2031 21.4279 17.3102C21.5404 17.4174 21.6036 17.5627 21.6036 17.7143C21.6036 17.8658 21.5404 18.0112 21.4279 18.1183C21.3153 18.2255 21.1627 18.2857 21.0036 18.2857H18.0012H18Z"
                  fill="#BB7AAF"
                />
              </svg>
            </span>
            Add a new book
          </button>
          <button
            onClick={() =>
              setModals((prevState) => ({ ...prevState, menu: false }))
            }
            className="w-[70px] h-[6px] bg-primary-white rounded-lg absolute top-4 left-[calc(50%-35px)]"
          ></button>
        </Transition.Child>
      </Transition>
      <Transition
        show={modals.profileDetails}
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="z-[99990] flex bottom-0 left-0 lg:hidden overflow-y-scroll bg-primary-white flex-col items-center lg:items-stretch lg:justify-between fixed w-screen min-h-screen  lg:min-h-[566px] lg:w-pop-up py-[42px] px-[21px] lg:p-8"
      >
        <h4 className="w-full flex items-center text-h4 text-tertiary-dark font-bold">
          <button
            onClick={() =>
              setModals((prevState) => ({
                ...prevState,
                profileDetails: false,
              }))
            }
            className="lg:hidden mr-[18px]"
          >
            <svg
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                fill="#702963"
              />
            </svg>
          </button>
          Personal Profile
        </h4>
        {/* <p className="hidden lg:block text-secondary-dark text-left my-6 font-[550]">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utv
          estiis ibulum bibendum egestas.
        </p> */}
        <div className=" flex my-6 mt-12 lg:mt-0 lg:my-0 justify-center items-center relative lg:absolute lg:top-40 lg:right-12 w-40 h-40 rounded-full bg-neutral-10">
          {!personalProfile.photo ? (
            <p
              typeof="file"
              className="w-10/12 text-center text-secondary-light text-p1"
            >
              Add a profile picture
            </p>
          ) : (
            <img
              className="w-full h-full rounded-full object-cover"
              src={
                personalProfile.local
                  ? URL.createObjectURL(personalProfile?.photo)
                  : `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/profiles/${user?.photo}`
              }
              alt="publisher's profile"
            />
          )}
          <label
            htmlFor="photo"
            className="w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute right-5 -top-1"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5 5.25L18.75 1.5L3.75 16.5L2.25 21.75L7.5 20.25L22.5 5.25ZM15.75 4.5L19.5 8.25L15.75 4.5ZM3.75 16.5L7.5 20.25L3.75 16.5Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </label>

          <input
            onChange={handleChange}
            name="photo"
            id="photo"
            type="file"
            className="hidden"
            disabled={user.isPCP ? false : true}
          />

          <button
            onClick={() =>
              setModals((prev) => ({ ...prev, deleteImage: true }))
            }
            className="w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute -right-1 top-7"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8 4.7998C13.8 4.32241 13.6104 3.86458 13.2728 3.52701C12.9352 3.18945 12.4774 2.9998 12 2.9998C11.5226 2.9998 11.0648 3.18945 10.7272 3.52701C10.3896 3.86458 10.2 4.32241 10.2 4.7998H9C9 4.00416 9.31607 3.24109 9.87868 2.67848C10.4413 2.11588 11.2044 1.7998 12 1.7998C12.7956 1.7998 13.5587 2.11588 14.1213 2.67848C14.6839 3.24109 15 4.00416 15 4.7998H20.4C20.5591 4.7998 20.7117 4.86302 20.8243 4.97554C20.9368 5.08806 21 5.24067 21 5.3998C21 5.55893 20.9368 5.71155 20.8243 5.82407C20.7117 5.93659 20.5591 5.9998 20.4 5.9998H19.7352L18.18 19.4758C18.1123 20.0607 17.8319 20.6003 17.3923 20.9919C16.9527 21.3835 16.3844 21.5999 15.7956 21.5998H8.2044C7.61562 21.5999 7.04735 21.3835 6.6077 20.9919C6.16806 20.6003 5.88771 20.0607 5.82 19.4758L4.2636 5.9998H3.6C3.45957 5.99985 3.32357 5.95064 3.21569 5.86074C3.10781 5.77084 3.03488 5.64594 3.0096 5.5078L3 5.3998C3 5.24067 3.06321 5.08806 3.17574 4.97554C3.28826 4.86302 3.44087 4.7998 3.6 4.7998H13.8ZM18.5256 5.9998H5.4732L7.0116 19.3378C7.04547 19.6303 7.18573 19.9002 7.40567 20.096C7.62562 20.2919 7.90991 20.4 8.2044 20.3998H15.7956C16.0899 20.3997 16.3739 20.2915 16.5936 20.0956C16.8133 19.8998 16.9534 19.6301 16.9872 19.3378L18.5256 5.9998ZM10.2 8.9998C10.494 8.9998 10.74 9.1858 10.7904 9.4306L10.8 9.5254V16.8754C10.8 17.1646 10.5312 17.3998 10.2 17.3998C9.906 17.3998 9.66 17.2138 9.6096 16.969L9.6 16.8742V9.5266C9.6 9.2362 9.8688 9.001 10.2 9.001V8.9998ZM13.8 8.9998C14.094 8.9998 14.34 9.1858 14.3904 9.4306L14.4 9.5254V16.8754C14.4 17.1646 14.1312 17.3998 13.8 17.3998C13.506 17.3998 13.26 17.2138 13.2096 16.969L13.2 16.8742V9.5266C13.2 9.2362 13.4688 9.001 13.8 9.001V8.9998Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        {/* body */}
        <form
          onSubmit={handleProfileChange}
          className="flex w-full lg:w-auto mt-4 flex-col justify-between"
        >
          <>
            <label className="text-p1 flex flex-row gap-2 font-semibold text-secondary-dark -mb-2">
              Name
              {user.isPCP && (
                <p className="flex gap-2 w-[135px] items-center text-p1 font-semibold text-tertiary-dark ">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 8.5C0 6.24566 0.895533 4.08365 2.48959 2.48959C4.08365 0.895533 6.24566 0 8.5 0C10.7543 0 12.9163 0.895533 14.5104 2.48959C16.1045 4.08365 17 6.24566 17 8.5C17 10.7543 16.1045 12.9163 14.5104 14.5104C12.9163 16.1045 10.7543 17 8.5 17C6.24566 17 4.08365 16.1045 2.48959 14.5104C0.895533 12.9163 0 10.7543 0 8.5H0ZM8.01493 12.138L12.9087 6.02027L12.0247 5.31307L7.85173 10.5275L4.896 8.0648L4.17067 8.9352L8.01493 12.1391V12.138Z"
                      fill="#FFD600"
                    />
                  </svg>
                  Primary
                </p>
              )}
            </label>
            <input
              type="text"
              name="fullName"
              value={personalProfile.fullName}
              placeholder="Enter name"
              className="pl-2 mt-4 outline-primary-light font-semibold w-full lg:w-40 h-12 bg-primary-white border-1 border-primary-light border-solid"
              onChange={handleChange}
              disabled
            />
          </>
          <>
            <label className="text-p1 mt-4 font-semibold text-secondary-dark -mb-2">
              Phone number
            </label>
            <input
              type="tel"
              name="mobile"
              value={personalProfile.mobile}
              placeholder="+91 991919199"
              className="pl-2  mt-4 outline-primary-light font-semibold w-full lg:w-48 h-12 bg-primary-white border-1 border-primary-light border-solid"
              onChange={handleChange}
              disabled
            />
          </>
          <>
            <label className="text-p1 mt-4 font-semibold text-secondary-dark -mb-2">
              Email address
            </label>
            <input
              type="email"
              name="email"
              value={personalProfile.email}
              placeholder="Enter your email"
              className="pl-2  mt-4 mb-8 outline-primary-light font-semibold w-full lg:w-64 h-12 bg-primary-white border-1 border-primary-light border-solid"
              onChange={handleChange}
              disabled
            />
          </>
          {personalProfile.photo && (
            <div className="hidden lg:flex w-full items-center justify-end">
              <BtnSmallWhite
                onClick={(e) => {
                  e.preventDefault();
                  setModals((prevState) => ({
                    ...prevState,
                    profileDetails: false,
                  }));
                }}
              >
                Cancel
              </BtnSmallWhite>
              <button className="bg-primary-dark text-primary-white text-[18px] font-[500] py-[14px] px-[58px] ml-3">
                {miniLoader ? (
                  <div className="flex">
                    <svg
                      className="animate-spin ml-1 mr-3 h-5 w-5 "
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-20"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </div>
                ) : (
                  "Update"
                )}

              </button>
            </div>
          )}
        </form>

        <button
          onClick={(e) => {
            setModals((prevState) => ({
              ...prevState,
              profileDetails: false,
            }));
            e.stopPropagation();
            setMiniLoader(false);
          }}
          className="hidden lg:block absolute top-8 right-8"
        >
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
              fill="black"
              fillOpacity="0.53"
            />
          </svg>
        </button>
      </Transition>
      {/* <DialogBox show={!user.tnCAccepted}>
        <div className=" w-[1090px] h-[731px] bg-[#fff] p-8">
          <div className="my-2 mb-4">
            <h2 className="text-[#702963] font-[600]  text-h3 mb-2 ">
              Terms &amp; Conditions
            </h2>
            <p className="text-[#BABABA] text-[19px] font-[600] ">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat mi commodo mi est cvolatiobh</p>
          </div>
          <div className="md:py-8 ">
            <h3 className="uppercase text-tertiary-dark font-bold md:font-semibold text-h5 mb-4 font-montserrat text-left">
              User Agreement
            </h3>
            <div
              style={{
                boxShadow:
                  "inset -1px -1px 4px rgba(0, 0, 0, 0.08), inset 1px 1px 4px rgba(0, 0, 0, 0.08)",
              }}
              className="relative h-[294px] scrollbar scrollbar-thumb-thumb scrollbar-track-track border-[1.5px] border-1 border-solid border-[#E4E3E3] p-6 pr-8 text-left mt-3 md:mt-2"
            >
              <p className="text-tertiary-dark font-[500] text-[18px] mb-6 leading-[24px] md:leading-[21px]">
                Lorem ipsum
              </p>
              <p className="text-heading-false font-[500] text-[18px] mb-6 leading-[24px] md:leading-[21px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Molestie aliquet amet duis suspendisse neque. Tristique
                condimentum sagittis lacinia vitae sagittis.
              </p>
              <p className="text-heading-false font-[500] text-[18px] mb-6 leading-[24px] md:leading-[21px]">
                Morbi adipiscing id commodo lectus sodales convallis egestas
                scelerisque. Dictumst orci velit, erat sodales euismod amet
                enim ultricies interdum. Sed in velit ut sed ac adipiscing
                suspendisse nulla odio. Metus massa tristique venenatis
                augue tristique sollicitudin viverra vivamus dolor. Morbi
                posuere vel sit mauris nunc urna, suspendisse. Nam rhoncus,
                elit et dignissim eu dolor. Cursus imperdiet dolor iaculis
                eu elit sit ornare purus
              </p>

              <p className="text-tertiary-dark font-[500] text-[18px] mb-6 leading-[24px] md:leading-[21px]">
                Lorem ipsum
              </p>

              <p className="text-heading-false font-[500] text-[18px] leading-[24px] md:leading-[21px] mb-6">
                Morbi adipiscing id commodo lectus sodales convallis egestas
                scelerisque. Dictumst orci velit, erat sodales euismod amet
                enim ultricies interdum. Sed in velit ut sed ac adipiscing
                suspendisse nulla odio. Metus massa tristique venenatis
                augue tristique sollicitudin viverra vivamus dolor. Morbi
                posuere vel sit mauris nunc urna, suspendisse. Nam rhoncus,
                elit et dignissim eu dolor. Cursus imperdiet dolor iaculis
                eu elit sit ornare purus.
                <br />
                Morbi adipiscing id commodo lectus sodales convallis egestas
                scelerisque. Dictumst orci velit, erat sodales euismod amet
                enim ultricies interdum. Sed in velit ut sed ac adipiscing
                suspendisse nulla odio. Metus massa tristique venenatis
                augue tristique sollicitudin viverra vivamus dolor. Morbi
                posuere vel sit mauris nunc urna, suspendisse. Nam rhoncus,
                elit et dignissim eu dolor. Cursus imperdiet dolor iaculis
                eu elit sit ornare purus.
              </p>

              <p className="text-tertiary-dark font-[500] text-[18px] mb-6 leading-[24px] md:leading-[21px]">
                Lorem ipsum
              </p>

              <p className="text-heading-false font-[500] text-[18px] leading-[24px] md:leading-[21px] mb-6">
                Morbi adipiscing id commodo lectus sodales convallis egestas
                scelerisque. Dictumst orci velit, erat sodales euismod amet
                enim ultricies interdum. Sed in velit ut sed ac adipiscing
                suspendisse nulla odio. Metus massa tristique venenatis
                augue tristique sollicitudin viverra vivamus dolor. Morbi
                posuere vel sit mauris nunc urna, suspendisse. Nam rhoncus,
                elit et dignissim eu dolor. Cursus imperdiet dolor iaculis
                eu elit sit ornare purus.
                <br />
                Morbi adipiscing id commodo lectus sodales convallis egestas
                scelerisque. Dictumst orci velit, erat sodales euismod amet
                enim ultricies interdum. Sed in velit ut sed ac adipiscing
                suspendisse nulla odio. Metus massa tristique venenatis
                augue tristique sollicitudin viverra vivamus dolor. Morbi
                posuere vel sit mauris nunc urna, suspendisse. Nam rhoncus,
                elit et dignissim eu dolor. Cursus imperdiet dolor iaculis
                eu elit sit ornare purus.
              </p>
              <div
                className="h-[82px] w-full sticky -bottom-[26px] left-0"
                style={{
                  background:
                    "linear-gradient(13.65deg, rgba(255, 255, 255, 0.88) 54.66%, rgba(255, 255, 255, 0) 136.81%)",
                }}
              ></div>
            </div>
          </div>
          <div className="mt-[50px] md:mt-[20px] flex items-start justify-between">
            <input
              type="checkbox"
              onChange={checkCheckBox}
              checked={checkBox}
              required
              className="mt-[5px] w-[30px] h-[27px] bg-primary-dark mr-4"
            />
            <p className="text-justify w-[calc(100%-48px)] text-heading-false font-[500] text-[18px] leading-[24px] md:leading-[21px] mt-2">
              I confirm that I have read and agree to the{" "}
              <RouterLink to="https://eprakashak.in/licence-agreement" target="_blank" className="text-tertiary-dark underline ">
                License Agreement
              </RouterLink>
              {"  "}
              <RouterLink to="https://eprakashak.in/terms-and-conditions" target="_blank" className="text-tertiary-dark underline ">
                Terms of Use
              </RouterLink>{" "}
              and{" "}
              <RouterLink to="https://eprakashak.in/privacy-policy" target="_blank" className="text-tertiary-dark underline ">
                Privacy Policy
              </RouterLink>{" "}
            </p>
          </div>
          <div className="w-full flex justify-end mt-10 ">
            {checkBox ? (
              <BtnSmall onClick={handleProfileChange} >Submit</BtnSmall>
            ) :
              (<BtnSmallDisabled>Submit</BtnSmallDisabled>)}
          </div>
        </div>
      </DialogBox> */}
      <DialogBox show={modals.profileDetails}>
        <div className={`hidden lg:flex bg-primary-white flex-col items-center lg:items-stretch ${personalProfile.photo ? "lg:justify-between" : "lg:justify-start gap-8"} relative w-screen min-h-screen lg:min-h-[510px] lg:w-pop-up py-[42px] px-[21px] lg:p-8`}>
          <h4 className="w-full flex items-center text-h4 text-tertiary-dark font-bold">
            <button
              onClick={() =>
                setModals((prevState) => ({
                  ...prevState,
                  profileDetails: false,
                }))
              }
              className="lg:hidden mr-[18px]"
            >
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                  fill="#702963"
                />
              </svg>
            </button>
            Personal Profile
          </h4>
          {/* <p className="hidden lg:block text-secondary-dark text-left my-6 font-[550]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utv
            estiis ibulum bibendum egestas.
          </p> */}

          <div className=" flex my-6 mt-12 lg:mt-0 lg:my-0 justify-center items-center relative lg:absolute lg:top-40 lg:right-12 w-40 h-40 rounded-full bg-neutral-10">
            {!personalProfile.photo ? (
              <p
                typeof="file"
                className="w-10/12 text-center text-secondary-light text-p1"
              >
                Add a profile picture
              </p>
            ) : (
              <img
                className="w-full h-full rounded-full object-cover"
                src={
                  personalProfile.local
                    ? URL.createObjectURL(personalProfile?.photo)
                    : `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/profiles/${user?.photo}`
                }
                alt="publisher's profile"
              />
            )}

            <label
              htmlFor="photo"
              className="cursor-pointer w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute right-5 -top-1"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5 5.25L18.75 1.5L3.75 16.5L2.25 21.75L7.5 20.25L22.5 5.25ZM15.75 4.5L19.5 8.25L15.75 4.5ZM3.75 16.5L7.5 20.25L3.75 16.5Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </label>
            <input
              onChange={handleChange}
              name="photo"
              id="photo"
              type="file"
              className="hidden"
              disabled={user.isPCP ? false : true}
            />

            <button
              onClick={() =>
                setModals((prev) => ({ ...prev, deleteImage: true }))
              }
              className="w-[34px] h-[34px] rounded-full bg-[#ebe8e8e8] flex items-center justify-center absolute -right-1 top-7"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8 4.7998C13.8 4.32241 13.6104 3.86458 13.2728 3.52701C12.9352 3.18945 12.4774 2.9998 12 2.9998C11.5226 2.9998 11.0648 3.18945 10.7272 3.52701C10.3896 3.86458 10.2 4.32241 10.2 4.7998H9C9 4.00416 9.31607 3.24109 9.87868 2.67848C10.4413 2.11588 11.2044 1.7998 12 1.7998C12.7956 1.7998 13.5587 2.11588 14.1213 2.67848C14.6839 3.24109 15 4.00416 15 4.7998H20.4C20.5591 4.7998 20.7117 4.86302 20.8243 4.97554C20.9368 5.08806 21 5.24067 21 5.3998C21 5.55893 20.9368 5.71155 20.8243 5.82407C20.7117 5.93659 20.5591 5.9998 20.4 5.9998H19.7352L18.18 19.4758C18.1123 20.0607 17.8319 20.6003 17.3923 20.9919C16.9527 21.3835 16.3844 21.5999 15.7956 21.5998H8.2044C7.61562 21.5999 7.04735 21.3835 6.6077 20.9919C6.16806 20.6003 5.88771 20.0607 5.82 19.4758L4.2636 5.9998H3.6C3.45957 5.99985 3.32357 5.95064 3.21569 5.86074C3.10781 5.77084 3.03488 5.64594 3.0096 5.5078L3 5.3998C3 5.24067 3.06321 5.08806 3.17574 4.97554C3.28826 4.86302 3.44087 4.7998 3.6 4.7998H13.8ZM18.5256 5.9998H5.4732L7.0116 19.3378C7.04547 19.6303 7.18573 19.9002 7.40567 20.096C7.62562 20.2919 7.90991 20.4 8.2044 20.3998H15.7956C16.0899 20.3997 16.3739 20.2915 16.5936 20.0956C16.8133 19.8998 16.9534 19.6301 16.9872 19.3378L18.5256 5.9998ZM10.2 8.9998C10.494 8.9998 10.74 9.1858 10.7904 9.4306L10.8 9.5254V16.8754C10.8 17.1646 10.5312 17.3998 10.2 17.3998C9.906 17.3998 9.66 17.2138 9.6096 16.969L9.6 16.8742V9.5266C9.6 9.2362 9.8688 9.001 10.2 9.001V8.9998ZM13.8 8.9998C14.094 8.9998 14.34 9.1858 14.3904 9.4306L14.4 9.5254V16.8754C14.4 17.1646 14.1312 17.3998 13.8 17.3998C13.506 17.3998 13.26 17.2138 13.2096 16.969L13.2 16.8742V9.5266C13.2 9.2362 13.4688 9.001 13.8 9.001V8.9998Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>

          {/* body */}
          <form
            onSubmit={handleProfileChange}
            className="flex w-full lg:w-auto mt-4 flex-col justify-between"
          >
            <>
              <label className="flex flex-row gap-3 items-center text-p1 font-semibold text-secondary-dark -mb-2">
                Name
                {user.isPCP && (
                  <p className="flex gap-2 w-[135px] items-center text-p1 font-semibold text-tertiary-dark ">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 8.5C0 6.24566 0.895533 4.08365 2.48959 2.48959C4.08365 0.895533 6.24566 0 8.5 0C10.7543 0 12.9163 0.895533 14.5104 2.48959C16.1045 4.08365 17 6.24566 17 8.5C17 10.7543 16.1045 12.9163 14.5104 14.5104C12.9163 16.1045 10.7543 17 8.5 17C6.24566 17 4.08365 16.1045 2.48959 14.5104C0.895533 12.9163 0 10.7543 0 8.5H0ZM8.01493 12.138L12.9087 6.02027L12.0247 5.31307L7.85173 10.5275L4.896 8.0648L4.17067 8.9352L8.01493 12.1391V12.138Z"
                        fill="#FFD600"
                      />
                    </svg>
                    Primary
                  </p>
                )}
              </label>
              <input
                type="text"
                name="fullName"
                value={personalProfile.fullName}
                placeholder="Enter name"
                className="pl-2 mt-4 outline-primary-light font-semibold w-full lg:w-40 h-12 bg-primary-white border-1 border-primary-light border-solid"
                onChange={handleChange}
                disabled
              />
            </>
            <>
              <label className="text-p1 mt-4 font-semibold text-secondary-dark -mb-2">
                Mobile Number
              </label>
              <input
                type="tel"
                name="mobile"
                value={personalProfile.mobile}
                placeholder="+91 991919199"
                className="pl-2  mt-4 outline-primary-light font-semibold w-full lg:w-48 h-12 bg-primary-white border-1 border-primary-light border-solid"
                onChange={handleChange}
                disabled
              />
            </>
            <>
              <label className="text-p1 mt-4 font-semibold text-secondary-dark -mb-2">
                Email address
              </label>
              <input
                type="email"
                name="email"
                value={personalProfile.email}
                placeholder="Enter your email"
                className="pl-2  mt-4 mb-8 outline-primary-light font-semibold w-full lg:w-64 h-12 bg-primary-white border-1 border-primary-light border-solid"
                onChange={handleChange}
                disabled
              />
            </>
            {personalProfile.photo && (
              <div className="hidden lg:flex w-full items-center justify-end">
                <BtnSmallWhite
                  onClick={(e) => {
                    e.preventDefault();
                    setModals((prevState) => ({
                      ...prevState,
                      profileDetails: false,
                    }));
                  }}
                >
                  Cancel
                </BtnSmallWhite>
                <button
                  type="submit"
                  className="bg-primary-dark text-primary-white text-[18px] font-[500] py-[14px] px-[58px] ml-3"
                >
                  {miniLoader ? (
                    <div className="flex">
                      <svg
                        className="animate-spin ml-1 mr-3 h-5 w-5 "
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-20"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </div>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            )}
          </form>

          <button
            onClick={(e) => {
              setModals((prevState) => ({
                ...prevState,
                profileDetails: false,
              }));
              e.stopPropagation();
            }}
            className="hidden lg:block absolute top-8 right-8"
          >
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                fill="black"
                fillOpacity="0.53"
              />
            </svg>
          </button>
        </div>
      </DialogBox>

      {/* profile popup */}
      <Transition
        show={modals.profile}
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="lg:hidden z-[999] rounded-t-[30px] text-center pt-10 px-6 fixed bg-[#ffffff] shadow-[0_4px_4px_3px_rgba(181,181,181,0.14)] bottom-0 left-0 w-full h-[271px] border-1 border-solid border-[#e7e7e7]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onTouchEnd={() =>
            setModals((prevState) => ({ ...prevState, profile: false }))
          }
          className="absolute top-3 left-[calc(50%-35px)] bg-[#ddd9d9] w-[70px] h-[6px] rounded-lg"
        ></button>
        <div className="flex flex-col h-[58%]">
          <button
            onClick={() =>
              setModals((prevState) => ({
                ...prevState,
                profileDetails: true,
                profile: false,
              }))
            }
            className="flex items-center text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
          >
            <span className="mr-5">
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.50016 15.75C13.4351 15.75 16.6252 12.7279 16.6252 9C16.6252 5.27213 13.4351 2.25 9.50016 2.25C5.56518 2.25 2.37516 5.27213 2.37516 9C2.37516 12.7279 5.56518 15.75 9.50016 15.75ZM9.50016 16.5C13.8725 16.5 17.4168 13.1423 17.4168 9C17.4168 4.85775 13.8725 1.5 9.50016 1.5C5.12779 1.5 1.5835 4.85775 1.5835 9C1.5835 13.1423 5.12779 16.5 9.50016 16.5Z"
                  fill="#8B8B8B"
                />
                <path
                  d="M4.75 13.3612C4.75 12.9738 5.05558 12.6464 5.4625 12.6037C8.51635 12.2834 10.4975 12.3123 13.5446 12.6108C13.6968 12.6259 13.841 12.6827 13.9597 12.7742C14.0783 12.8657 14.1663 12.988 14.2128 13.1261C14.2593 13.2642 14.2624 13.4121 14.2216 13.5518C14.1808 13.6915 14.098 13.8169 13.9832 13.9128C10.3871 16.8824 8.3319 16.8415 5.00333 13.9158C4.84104 13.7733 4.75 13.5708 4.75 13.3615V13.3612Z"
                  fill="#8B8B8B"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.5042 12.9837C10.4812 12.6875 8.52856 12.6597 5.50597 12.9766C5.30252 12.998 5.14616 13.1626 5.14616 13.3617C5.14616 13.469 5.19327 13.5706 5.27283 13.6411C6.92266 15.0909 8.1727 15.746 9.39464 15.7501C10.6209 15.7542 11.9383 15.1044 13.7235 13.6306C13.7802 13.5828 13.821 13.5204 13.841 13.451C13.861 13.3816 13.8592 13.3082 13.836 13.2397C13.8128 13.1712 13.7691 13.1106 13.7101 13.0652C13.6512 13.0199 13.5797 12.9917 13.5042 12.9841V12.9837ZM5.41929 12.2311C8.5052 11.9075 10.5152 11.9367 13.5861 12.2379C13.815 12.2605 14.032 12.3459 14.2105 12.4835C14.389 12.6212 14.5212 12.8052 14.591 13.0129C14.6608 13.2207 14.6652 13.4432 14.6036 13.6533C14.5419 13.8634 14.417 14.0519 14.244 14.1957C12.4331 15.6912 10.9249 16.5057 9.39226 16.5001C7.85524 16.4949 6.41362 15.6665 4.73489 14.1909C4.6147 14.0848 4.51888 13.9564 4.45343 13.8137C4.38798 13.6709 4.3543 13.517 4.35449 13.3614C4.35392 13.0818 4.46224 12.8118 4.65872 12.6032C4.85519 12.3946 5.12601 12.2619 5.41929 12.2307V12.2311Z"
                  fill="#8B8B8B"
                />
                <path
                  d="M12.6668 7.5C12.6668 8.29565 12.3332 9.05871 11.7393 9.62132C11.1455 10.1839 10.34 10.5 9.50016 10.5C8.66031 10.5 7.85486 10.1839 7.26099 9.62132C6.66713 9.05871 6.3335 8.29565 6.3335 7.5C6.3335 6.70435 6.66713 5.94129 7.26099 5.37868C7.85486 4.81607 8.66031 4.5 9.50016 4.5C10.34 4.5 11.1455 4.81607 11.7393 5.37868C12.3332 5.94129 12.6668 6.70435 12.6668 7.5Z"
                  fill="#8B8B8B"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.50016 9.75C10.1301 9.75 10.7341 9.51295 11.1795 9.09099C11.6249 8.66903 11.8752 8.09674 11.8752 7.5C11.8752 6.90326 11.6249 6.33097 11.1795 5.90901C10.7341 5.48705 10.1301 5.25 9.50016 5.25C8.87027 5.25 8.26618 5.48705 7.82078 5.90901C7.37539 6.33097 7.12516 6.90326 7.12516 7.5C7.12516 8.09674 7.37539 8.66903 7.82078 9.09099C8.26618 9.51295 8.87027 9.75 9.50016 9.75ZM9.50016 10.5C10.34 10.5 11.1455 10.1839 11.7393 9.62132C12.3332 9.05871 12.6668 8.29565 12.6668 7.5C12.6668 6.70435 12.3332 5.94129 11.7393 5.37868C11.1455 4.81607 10.34 4.5 9.50016 4.5C8.66031 4.5 7.85486 4.81607 7.26099 5.37868C6.66713 5.94129 6.3335 6.70435 6.3335 7.5C6.3335 8.29565 6.66713 9.05871 7.26099 9.62132C7.85486 10.1839 8.66031 10.5 9.50016 10.5Z"
                  fill="#8B8B8B"
                />
              </svg>
            </span>
            Personal Profile
          </button>

          <button
            onClick={() => navigate(ROUTES.BUSINESS_PROFILE)}
            className="ml-[2px] flex items-center text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
          >
            <span className="mr-5">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.625 11.1562C10.625 11.4498 10.3873 11.6875 10.0938 11.6875H6.90625C6.61273 11.6875 6.375 11.4498 6.375 11.1562V9.5625H0V14.3438C0 15.1938 0.74375 15.9375 1.59375 15.9375H15.4062C16.2563 15.9375 17 15.1938 17 14.3438V9.5625H10.625V11.1562ZM15.4062 4.25H12.75V2.65625C12.75 1.80625 12.0063 1.0625 11.1562 1.0625H5.84375C4.99375 1.0625 4.25 1.80625 4.25 2.65625V4.25H1.59375C0.74375 4.25 0 4.99375 0 5.84375V8.5H17V5.84375C17 4.99375 16.2563 4.25 15.4062 4.25ZM10.625 4.25H6.375V3.1875H10.625V4.25Z"
                  fill="#8B8B8B"
                />
              </svg>
            </span>
            Business Profile
          </button>
          <button
            onClick={() => navigate(ROUTES.SETTINGS)}
            className="flex items-center text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
          >
            <span className="mr-5">
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.1158 1.73325C12.4243 1.58586 11.7186 1.50769 11.0101 1.5C10.2841 1.5075 9.57775 1.58625 8.88554 1.73325C8.73793 1.76477 8.60434 1.83955 8.50346 1.94714C8.40259 2.05473 8.33948 2.18973 8.32297 2.33325L8.15875 3.741C8.13521 3.93956 8.06331 4.13011 7.94879 4.29738C7.83427 4.46466 7.68032 4.60403 7.49926 4.70433C7.3182 4.80463 7.11505 4.86308 6.90608 4.87501C6.69711 4.88693 6.48811 4.852 6.29582 4.773L4.9444 4.20525C4.80722 4.14761 4.65467 4.13209 4.50785 4.16084C4.36103 4.1896 4.22721 4.2612 4.1249 4.36575C3.14751 5.36404 2.41979 6.56075 1.9964 7.866C1.95179 8.00341 1.95309 8.15067 2.00011 8.28734C2.04714 8.42402 2.13755 8.54334 2.25882 8.62875L3.45861 9.4725C3.62737 9.59105 3.76456 9.74581 3.85912 9.9243C3.95367 10.1028 4.00294 10.3 4.00294 10.5C4.00294 10.7 3.95367 10.8972 3.85912 11.0757C3.76456 11.2542 3.62737 11.409 3.45861 11.5275L2.25882 12.3735C2.13771 12.4589 2.04739 12.5781 2.00038 12.7146C1.95336 12.8511 1.95197 12.9982 1.9964 13.1355C2.41892 14.4419 3.14611 15.6399 4.12332 16.6395C4.22554 16.7442 4.35932 16.8159 4.50615 16.8448C4.65297 16.8737 4.80557 16.8583 4.94282 16.8008L6.30054 16.2315C6.49171 16.1518 6.69982 16.1161 6.90809 16.1273C7.11636 16.1385 7.31896 16.1963 7.49954 16.296C7.86568 16.4985 8.11004 16.8548 8.15797 17.2568L8.3214 18.6645C8.33781 18.8061 8.39959 18.9394 8.4983 19.0462C8.59701 19.1531 8.72785 19.2283 8.87297 19.2615C10.2711 19.5797 11.7279 19.5797 13.126 19.2615C13.2712 19.2283 13.402 19.1531 13.5007 19.0462C13.5994 18.9394 13.6612 18.8061 13.6776 18.6645L13.841 17.2545C13.8632 17.0558 13.9342 16.8649 14.0482 16.6974C14.1622 16.5298 14.3161 16.3903 14.4972 16.2902C14.6784 16.19 14.8817 16.1321 15.0907 16.1212C15.2997 16.1102 15.5085 16.1464 15.7 16.227L17.057 16.7963C17.1942 16.8538 17.3468 16.8692 17.4936 16.8403C17.6405 16.8114 17.7743 16.7397 17.8765 16.635C18.8532 15.6365 19.5803 14.4398 20.0034 13.1348C20.048 12.9973 20.0467 12.8501 19.9997 12.7134C19.9527 12.5767 19.8622 12.4574 19.741 12.372L18.5428 11.5275C18.3739 11.409 18.2367 11.2543 18.1421 11.0758C18.0474 10.8974 17.9981 10.7002 17.998 10.5002C17.998 10.3002 18.0471 10.103 18.1416 9.92444C18.2361 9.74592 18.3733 9.59111 18.542 9.4725L19.7402 8.62725C19.8612 8.54179 19.9513 8.42256 19.9982 8.28604C20.0451 8.14953 20.0463 8.00248 20.0018 7.86525C19.5787 6.56005 18.8513 5.36334 17.8741 4.365C17.7718 4.26045 17.638 4.18885 17.4912 4.16009C17.3443 4.13134 17.1918 4.14686 17.0546 4.2045L15.7032 4.77225C15.535 4.84371 15.353 4.88051 15.1689 4.88025C14.8398 4.87967 14.5224 4.76318 14.2777 4.5531C14.0329 4.34301 13.878 4.05411 13.8426 3.74175L13.6776 2.3325C13.6612 2.18928 13.5983 2.05453 13.4977 1.9471C13.3971 1.83966 13.2639 1.7649 13.1166 1.73325H13.1158ZM10.9999 13.5C10.1664 13.5 9.36696 13.1839 8.77756 12.6213C8.18816 12.0587 7.85704 11.2957 7.85704 10.5C7.85704 9.70435 8.18816 8.94129 8.77756 8.37868C9.36696 7.81607 10.1664 7.5 10.9999 7.5C11.8334 7.5 12.6328 7.81607 13.2222 8.37868C13.8116 8.94129 14.1428 9.70435 14.1428 10.5C14.1428 11.2957 13.8116 12.0587 13.2222 12.6213C12.6328 13.1839 11.8334 13.5 10.9999 13.5Z"
                  fill="#8B8B8B"
                />
              </svg>
            </span>
            Account Settings
          </button>
          <button
            onClick={handleSignout}
            className="flex items-center text-mobile-h4 sm:text-tablet-h4 lg:text-h4 text-secondary-dark w-full h-1/4"
          >
            <span className="mr-5">
              <svg
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.5 3.26562C2.5 2.1185 3.48 1.1875 4.6875 1.1875H7.8125C8.06114 1.1875 8.2996 1.28133 8.47541 1.44836C8.65123 1.61538 8.75 1.84192 8.75 2.07812C8.75 2.31433 8.65123 2.54087 8.47541 2.70789C8.2996 2.87492 8.06114 2.96875 7.8125 2.96875H4.6875C4.60462 2.96875 4.52513 3.00003 4.46653 3.0557C4.40792 3.11138 4.375 3.18689 4.375 3.26562V15.7344C4.375 15.8982 4.515 16.0312 4.6875 16.0312H7.8125C8.06114 16.0312 8.2996 16.1251 8.47541 16.2921C8.65123 16.4591 8.75 16.6857 8.75 16.9219C8.75 17.1581 8.65123 17.3846 8.47541 17.5516C8.2996 17.7187 8.06114 17.8125 7.8125 17.8125H4.6875C4.10734 17.8125 3.55094 17.5936 3.1407 17.2038C2.73047 16.8141 2.5 16.2855 2.5 15.7344V3.26562ZM15.55 8.60938H8.4375C8.18886 8.60938 7.9504 8.70321 7.77459 8.87023C7.59877 9.03726 7.5 9.26379 7.5 9.5C7.5 9.73621 7.59877 9.96274 7.77459 10.1298C7.9504 10.2968 8.18886 10.3906 8.4375 10.3906H15.55L13.0875 12.73C12.9954 12.8115 12.9215 12.9099 12.8703 13.0191C12.819 13.1284 12.7915 13.2463 12.7893 13.3659C12.787 13.4855 12.8102 13.6042 12.8573 13.7151C12.9045 13.826 12.9747 13.9268 13.0637 14.0114C13.1527 14.0959 13.2588 14.1626 13.3755 14.2074C13.4922 14.2522 13.6173 14.2742 13.7432 14.2721C13.869 14.27 13.9932 14.2438 14.1082 14.1951C14.2232 14.1464 14.3267 14.0763 14.4125 13.9887L18.475 10.1294C18.6506 9.96238 18.7492 9.73602 18.7492 9.5C18.7492 9.26398 18.6506 9.03762 18.475 8.87062L14.4125 5.01125C14.3267 4.92375 14.2232 4.85356 14.1082 4.80488C13.9932 4.75621 13.869 4.73003 13.7432 4.72792C13.6173 4.72581 13.4922 4.74781 13.3755 4.7926C13.2588 4.8374 13.1527 4.90407 13.0637 4.98864C12.9747 5.07321 12.9045 5.17395 12.8573 5.28485C12.8102 5.39575 12.787 5.51454 12.7893 5.63412C12.7915 5.75371 12.819 5.87164 12.8703 5.98089C12.9215 6.09014 12.9954 6.18846 13.0875 6.27L15.55 8.60938Z"
                  fill="#8B8B8B"
                />
              </svg>
            </span>
            Log Out
          </button>
        </div>
        <button
          onClick={() =>
            setModals((prevState) => ({ ...prevState, profile: false }))
          }
          className="w-[113px] mt-7 rounded-md bg-neutral-10 py-[6px] px-7 text-secondary-dark font-semibold text-montserrat text-h5 leading-[22px]"
        >
          Close
        </button>
      </Transition>
      <DialogBox show={modals.deleteImage}>
        <PopUp
          onClick={() => deletePicture()}
          onClose={() => setModals((prev) => ({ ...prev, deleteImage: false }))}
          button="Confirm"
          title="Plesae Confirm to continue"
          main="Sussane Roberts has been removed from your team"
          body="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget utvest-ibulum bibendum egestas. Enim mi arcu convallis enim purus interdum. Ut neque at adipiscing tortor facilisis sagittis libero. Ac bibendum vel blandit."
        />
      </DialogBox>
    </>
  );
}
